import gql from 'graphql-tag';
import * as Urql from 'urql';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = { [_ in K]?: never };
export type Incremental<T> = T | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: { input: string; output: string; }
  String: { input: string; output: string; }
  Boolean: { input: boolean; output: boolean; }
  Int: { input: number; output: number; }
  Float: { input: number; output: number; }
};

/** A reference to an entity involved in an activity. */
export type ActivityEntityReference = {
  __typename?: 'ActivityEntityReference';
  /** The full NivaasIdentifier of the entity. */
  id: Scalars['ID']['output'];
};

/** An entry in the activity feed representing a single action. */
export type ActivityEntry = Identifiable & Traceable & {
  __typename?: 'ActivityEntry';
  /** The actor who performed the activity. */
  actor: StaffPublic;
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The list of field changes (for update activities). */
  changes?: Maybe<Array<Maybe<ActivityFieldChange>>>;
  /** Content of the activity (for comments). */
  content?: Maybe<Scalars['String']['output']>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** The primary object of the activity. */
  object: ActivityEntityReference;
  /** The origin entity (for move operations). */
  origin?: Maybe<ActivityEntityReference>;
  /** A human-readable summary of what happened. */
  summary: Scalars['String']['output'];
  /** The target entity (for add/remove/move operations). */
  target?: Maybe<ActivityEntityReference>;
  /** The type of activity. */
  type: ActivityType;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** A single field change within an activity. */
export type ActivityFieldChange = {
  __typename?: 'ActivityFieldChange';
  /** The value after the change (JSON serialized). */
  after?: Maybe<Scalars['String']['output']>;
  /** The value before the change (JSON serialized). */
  before?: Maybe<Scalars['String']['output']>;
  /** A human-readable label for the property. */
  label: Scalars['String']['output'];
  /** The property name that changed. */
  property: Scalars['String']['output'];
};

/** Query input for fetching activity entries for an entity. */
export type ActivityForEntityInput = {
  /** The full NivaasIdentifier of the entity. */
  entityId: Scalars['String']['input'];
  /** Maximum number of activity entries to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** The type of activity that occurred. */
export enum ActivityType {
  /** An entity was added to a collection. */
  Add = 'ADD',
  /** A comment was added. */
  Comment = 'COMMENT',
  /** A new entity was created. */
  Create = 'CREATE',
  /** An existing entity was deleted. */
  Delete = 'DELETE',
  /** An entity was moved. */
  Move = 'MOVE',
  /** An entity was removed from a collection. */
  Remove = 'REMOVE',
  /** An existing entity was updated. */
  Update = 'UPDATE'
}

/** Command to add a guest to a lead. */
export type AddGuestToLeadInput = {
  /** Guest to add to the lead. */
  guest: GuestLeadInput;
  /** ID of the lead to add the guest to. */
  id: Scalars['ID']['input'];
};

/** Command to add an item to a lead. */
export type AddItemToLeadInput = {
  /** ID of the lead to add the item to. */
  leadId: Scalars['String']['input'];
  /** ID of the offering they are interested in. */
  offeringId: Scalars['String']['input'];
  /** Quantity of offerings they are interested in. */
  quantity: Scalars['Int']['input'];
};

/** Command to attach a payment to a booking. */
export type AddPaymentInput = {
  /** ID of the booking to attach the payment to. */
  booking: Scalars['String']['input'];
  /** Payment information to add to the booking. */
  payment: PaymentInput;
};

/** Command to add a pricing strategy to an offering. */
export type AddPricingStrategyInput = {
  /** Data required to define a pricing strategy. */
  pricing: PricingStrategyInput;
  /** ID reference to the room offering this pricing is part of. */
  roomOffering: Scalars['String']['input'];
};

/** Command to add a supplementary item. */
export type AddSupplementaryItemInput = {
  /** ID of the booking to add the supplementary item to. */
  booking: Scalars['String']['input'];
  /** Supplementary item to add to the booking. */
  item: SupplementaryItemInput;
};

/** Command to add a transfer request to a booking. */
export type AddTransferRequestInput = {
  /** ID of the booking to add the transfer request to. */
  booking: Scalars['String']['input'];
  /** Transfer request to add to the booking. */
  transfer: TransferRequestInput;
};

/** An agent is a Team of type PARTNER with commission tracking. Represents an external agency company through whom bookings can be made. */
export type Agent = Identifiable & Team & {
  __typename?: 'Agent';
  /** Bookings made by this agent. */
  bookingsConnection?: Maybe<AgentBookingsConnection>;
  /** Commissions for this agent. */
  commissions: Array<Maybe<AgentCommission>>;
  /** Main contact person name. */
  contactName: Scalars['String']['output'];
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** Contact email for the team. */
  email: Scalars['String']['output'];
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Display name of the team. */
  name: Scalars['String']['output'];
  /** Payments made by this agent to Nivaas. */
  paymentsConnection?: Maybe<AgentPaymentsConnection>;
  /** Contact phone for the team. */
  phoneNumber: Scalars['String']['output'];
  /** Agents are always of type PARTNER. */
  type: TeamType;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
  /** Team website. */
  url: Scalars['String']['output'];
  /** Workspaces this team has access to. Staff members inherit workspace access from their team. */
  workspaces: Array<Maybe<Workspace>>;
};


/** An agent is a Team of type PARTNER with commission tracking. Represents an external agency company through whom bookings can be made. */
export type AgentBookingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};


/** An agent is a Team of type PARTNER with commission tracking. Represents an external agency company through whom bookings can be made. */
export type AgentPaymentsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Connection between Agent and bookings */
export type AgentBookingsConnection = {
  __typename?: 'AgentBookingsConnection';
  edges?: Maybe<Array<Maybe<AgentBookingsEdge>>>;
  pageInfo: AgentBookingsPageInfo;
};

/** Edge between Agent and bookings */
export type AgentBookingsEdge = {
  __typename?: 'AgentBookingsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Booking>;
};

/** Page info for connection between Agent and bookings */
export type AgentBookingsPageInfo = {
  __typename?: 'AgentBookingsPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

/** Commission details for an agent. */
export type AgentCommission = {
  __typename?: 'AgentCommission';
  /** Commission percentage. */
  commissionPercentage: Scalars['Int']['output'];
  /** Offering to which this commission applies. */
  offering: RoomOffering;
};

/** Data needed to create a new commission for an agent. */
export type AgentCommissionInput = {
  /** Commission percentage. */
  commissionPercentage: Scalars['Int']['input'];
  /** Offering to which this commission applies. */
  offering: Scalars['String']['input'];
};

/** Computed ledger summary for an agent. Shows their financial position with Nivaas. */
export type AgentLedgerSummary = {
  __typename?: 'AgentLedgerSummary';
  /** Credit available to settle bookings (paid - already settled). */
  availableCredit: Scalars['Float']['output'];
  /** Outstanding balance (owed - paid). */
  outstandingBalance: Scalars['Float']['output'];
  /** Total pending payments (submitted but not yet confirmed by operator). */
  pendingPayments: Scalars['Float']['output'];
  /** Total amount owed to Nivaas (sum of amountEarned for confirmed bookings). */
  totalOwedToNivaas: Scalars['Float']['output'];
  /** Total amount paid to Nivaas (sum of confirmed payments). */
  totalPaidToNivaas: Scalars['Float']['output'];
};

/** A payment made by an agent to the Nivaas platform. These payments build up credit that agents can use to settle bookings. */
export type AgentPayment = Identifiable & Traceable & {
  __typename?: 'AgentPayment';
  /** Amount paid to Nivaas. */
  amount: Price;
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** Timestamp when the payment was confirmed (if confirmed). */
  confirmedAt?: Maybe<Scalars['Float']['output']>;
  /** The operator who confirmed this payment. */
  confirmedBy?: Maybe<StaffPublic>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Optional description or note about the payment. */
  note?: Maybe<Scalars['String']['output']>;
  /** Bank transfer or payment reference. */
  reference: Scalars['String']['output'];
  /** Status of this payment. */
  status: AgentPaymentStatus;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** Status of an agent payment to Nivaas. */
export enum AgentPaymentStatus {
  /** Payment confirmed as received by operator. */
  Confirmed = 'CONFIRMED',
  /** Payment lodged by agent, awaiting confirmation by operator. */
  Pending = 'PENDING',
  /** Payment rejected by operator. */
  Rejected = 'REJECTED'
}

/** Connection between Agent and payments */
export type AgentPaymentsConnection = {
  __typename?: 'AgentPaymentsConnection';
  edges?: Maybe<Array<Maybe<AgentPaymentsEdge>>>;
  pageInfo: AgentPaymentsPageInfo;
};

/** Edge between Agent and payments */
export type AgentPaymentsEdge = {
  __typename?: 'AgentPaymentsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<AgentPayment>;
};

/** Page info for connection between Agent and payments */
export type AgentPaymentsPageInfo = {
  __typename?: 'AgentPaymentsPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

/** Tracks whether an agent has settled a booking with Nivaas. Settlement means the agent has allocated credit to cover their debt for this booking. */
export type AgentSettlement = {
  __typename?: 'AgentSettlement';
  /** Whether the agent has settled this booking with Nivaas. */
  settled: Scalars['Boolean']['output'];
  /** Timestamp when the booking was settled. */
  settledAt: Scalars['Float']['output'];
};

/** An aggregation -> B is part of A, but can exist independent of A. */
export type AggregatedBy = Relationship & {
  __typename?: 'AggregatedBy';
  /** Relationship entity. */
  entities: Array<Maybe<Identifiable>>;
  /** Relationship type of an aggregation. */
  type: RelationshipType;
};

/** An association -> B uses A, and can exist independent of A. */
export type AssociatedWith = {
  __typename?: 'AssociatedWith';
  /** ID of the entity instance it is related to. */
  id: Scalars['ID']['output'];
  /** Relationship type of an association. */
  type: RelationshipType;
};

/** Attach a file to an invoice. */
export type AttachFileToInvoiceInput = {
  /** Attachment ID to associate. */
  attachment: Scalars['String']['input'];
  /** Invoice to attach the file to. */
  invoice: Scalars['String']['input'];
};

/** Represents a general file attachment. */
export type Attachment = Identifiable & {
  __typename?: 'Attachment';
  /** When the attachment was created. */
  createdAt: Scalars['Float']['output'];
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** The name of the attachment. */
  name: Scalars['String']['output'];
  /** The size of the attachment. */
  size: Scalars['Int']['output'];
};

/** Check if a staff member is logged in. */
export type AuthenticateStaffInput = {
  /** {@link Staff.id} */
  id?: InputMaybe<Scalars['ID']['input']>;
};

/** Represents a customer made booking. Can include multiple offerings. */
export type Booking = Identifiable & Traceable & {
  __typename?: 'Booking';
  /** Whether the customer has accepted booking terms. */
  acceptedTerms: Scalars['Boolean']['output'];
  /** Agent associated with this booking. */
  agent?: Maybe<Agent>;
  /** Start date of the booking. */
  arrivalDate: Scalars['String']['output'];
  /** Attachments associated with this booking. */
  attachments: Array<Maybe<Attachment>>;
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** Customer who made this booking. */
  customer: Customer;
  /** End date of the booking. */
  departureDate: Scalars['String']['output'];
  /** Optional experiences included on the booking. */
  experiences?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** An external reference to the booking. */
  externalReference?: Maybe<Scalars['String']['output']>;
  /** Guests part of this booking. */
  guests: Array<Maybe<Guest>>;
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Optional instructions on the booking. */
  instructions: Array<Maybe<Scalars['String']['output']>>;
  /** Invoices associated with this booking. */
  invoices: Array<Maybe<Invoice>>;
  /** Items part of this booking. */
  items: Array<Maybe<BookingItem>>;
  /** Optional notes on the booking. */
  notes: Array<Maybe<Scalars['String']['output']>>;
  /** Package this booking was made with (if any). */
  package?: Maybe<Package>;
  /** Unique reference for the booking. */
  reference: Scalars['String']['output'];
  /** Reservation associated with this booking, only added after the booking is confirmed. */
  reservation?: Maybe<Reservation>;
  /** Settlement status with Nivaas (only for agent bookings). Tracks whether the agent has paid Nivaas their portion (amountEarned) for this booking. */
  settlement?: Maybe<AgentSettlement>;
  /** Source of the booking. */
  source: BookingSource;
  /** Status of the booking. */
  status: BookingStatus;
  /** Transfer requests associated with this booking. */
  transfers: Array<Maybe<TransferRequest>>;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** An extra selected for a booking item. Quantity represents the TOTAL count of extras, not per room. */
export type BookingExtraItem = {
  __typename?: 'BookingExtraItem';
  /** GST percentage (copied from offering extra at booking time). */
  gst: Scalars['Int']['output'];
  /** Price per unit (copied from offering extra at booking time). */
  price: Price;
  /** Total quantity of this extra (NOT per room). */
  quantity: Scalars['Int']['output'];
  /** Type of extra (references OfferingExtra.type). */
  type: ExtraType;
};

/** Input for an extra on a booking item. */
export type BookingExtraItemInput = {
  /** Total quantity of this extra (NOT per room). */
  quantity: Scalars['Int']['input'];
  /** Type of extra (references OfferingExtra.type). */
  type: ExtraType;
};

/** Represents a single booking item. */
export type BookingItem = {
  __typename?: 'BookingItem';
  /** Discount applied to this booking item. */
  discount?: Maybe<Scalars['Float']['output']>;
  /** Extras selected for this booking item. */
  extras?: Maybe<Array<Maybe<BookingExtraItem>>>;
  /** The offering instance being booked. */
  offering: RoomOffering;
  /** Pricing strategy used for this booking item. */
  pricing: PricingStrategy;
  /** Quantity of an offering being booked. */
  quantity: Scalars['Int']['output'];
};

/** Represents a single booking item. */
export type BookingItemInput = {
  /** Discount applied to this booking item. */
  discount?: InputMaybe<Scalars['Float']['input']>;
  /** Extras selected for this booking item. */
  extras?: InputMaybe<Array<InputMaybe<BookingExtraItemInput>>>;
  /** The offering instance being booked. */
  offering: Scalars['String']['input'];
  /** Quantity of an offering being booked. */
  quantity: Scalars['Int']['input'];
};

/** Source of a booking. */
export enum BookingSource {
  /** The booking came through an external agent. */
  Agent = 'AGENT',
  /** The booking was made through an offline, internal source - phone, cold-call, etc. */
  Offline = 'OFFLINE',
  /** The booking was made online. */
  Online = 'ONLINE'
}

/** Status of a booking. */
export enum BookingStatus {
  /** The booking has been cancelled with any required refunds. */
  Cancelled = 'CANCELLED',
  /** The booking has been confirmed, with comms sent to the customer. */
  Confirmed = 'CONFIRMED',
  /** The booking is waiting for all information to be added to it before initiating a payment. */
  Incomplete = 'INCOMPLETE',
  /** The booking has been partially paid out. */
  PartiallyPaid = 'PARTIALLY_PAID',
  /** The booking is waiting for payment to be made. */
  WaitingForPayment = 'WAITING_FOR_PAYMENT'
}

/** Command to calculate the price of a booking. */
export type CalculateBookingPriceInput = {
  /** Agent to calculate commission for. If not provided, no commission is applied. */
  agent?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the booking. */
  arrivalDate: Scalars['String']['input'];
  /** End date of the booking. */
  departureDate: Scalars['String']['input'];
  /** Items part of this booking. */
  items: Array<InputMaybe<BookingItemInput>>;
  /** Supplementary items attached to this booking. */
  supplementaryItems?: InputMaybe<Array<InputMaybe<SupplementaryItemInput>>>;
};

/** Query to check if an agent can settle a specific booking. */
export type CanSettleBookingInput = {
  /** ID of the booking to check. */
  booking: Scalars['String']['input'];
};

/** Result indicating if an agent can settle a specific booking. */
export type CanSettleBookingResult = {
  __typename?: 'CanSettleBookingResult';
  /** Available credit the agent has. */
  available: Scalars['Float']['output'];
  /** Whether the agent can settle this booking. */
  canSettle: Scalars['Boolean']['output'];
  /** Reason why the booking cannot be settled, if applicable. */
  reason?: Maybe<Scalars['String']['output']>;
  /** Amount required to settle the booking (amountEarned). */
  required: Scalars['Float']['output'];
};

/** Command to cancel a booking. */
export type CancelBookingInput = {
  /** ID of the booking to cancel. */
  booking: Scalars['String']['input'];
};

/** Command to cancel a booking. */
export type CancelBookingsInput = {
  /** Bookings to cancel. */
  bookings: Array<InputMaybe<Scalars['String']['input']>>;
};

/** Command to cancel a lead. */
export type CancelLeadInput = {
  /** ID of the lead to cancel. */
  leadId: Scalars['String']['input'];
};

/** A composition -> B is part of A, and cannot exist independent of A. */
export type ComposedOf = Relationship & {
  __typename?: 'ComposedOf';
  /** Relationship entity. */
  entities: Array<Maybe<Identifiable>>;
  /** Relationship type of an composition. */
  type: RelationshipType;
};

/** Command to confirm an agent payment (by operator). */
export type ConfirmAgentPaymentInput = {
  /** ID of the payment to confirm. */
  payment: Scalars['String']['input'];
};

/** Command to convert a lead. */
export type ConvertLeadInput = {
  /** ID of the lead to convert to a booking. */
  leadId: Scalars['String']['input'];
};

/** Command to create a new agent. */
export type CreateAgentInput = {
  /** Commissions for this agent. */
  commissions?: InputMaybe<Array<InputMaybe<AgentCommissionInput>>>;
  /** Name of main contact person. */
  contactName: Scalars['String']['input'];
  /** Email address on which this agent can be reached. */
  email: Scalars['String']['input'];
  /** Name of the agent company. */
  name: Scalars['String']['input'];
  /** Phone number of the agent. */
  phoneNumber: Scalars['String']['input'];
  /** Website of the agent. */
  url: Scalars['String']['input'];
  /** Workspaces this agent has access to. */
  workspaces: Array<InputMaybe<Scalars['String']['input']>>;
};

/** Command to create a new agent payment (lodged by agent). */
export type CreateAgentPaymentInput = {
  /** Amount being paid to Nivaas. */
  amount: PriceInput;
  /** Optional description or note about the payment. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Bank transfer or payment reference. */
  reference: Scalars['String']['input'];
};

/** Command to create a new booking. */
export type CreateBookingInput = {
  /** Agent associated with this booking. */
  agent?: InputMaybe<Scalars['String']['input']>;
  /** Start date of the booking. */
  arrivalDate: Scalars['String']['input'];
  /** When the booking was created. */
  createdAt?: InputMaybe<Scalars['Float']['input']>;
  /** Email address of the customer */
  customerEmail: Scalars['String']['input'];
  /** Full name of the customer */
  customerName: Scalars['String']['input'];
  /** Phone number of the customer */
  customerPhoneNumber: Scalars['String']['input'];
  /** Phone number of the customer */
  customerType?: InputMaybe<CustomerType>;
  /** End date of the booking. */
  departureDate: Scalars['String']['input'];
  /** Experiences attached to this booking. */
  experiences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** External reference for the booking. */
  externalReference?: InputMaybe<Scalars['String']['input']>;
  /** Guests part of this booking. */
  guests: Array<InputMaybe<GuestInput>>;
  /** Notes attached to this booking. */
  instructions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Items part of this booking. */
  items: Array<InputMaybe<BookingItemInput>>;
  /** Notes attached to this booking. */
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Package this booking is associated with. */
  package?: InputMaybe<Scalars['String']['input']>;
  /** Payments attached to this booking. */
  payments?: InputMaybe<Array<InputMaybe<PaymentInput>>>;
  /** Reference for the booking. */
  reference: Scalars['String']['input'];
  /** Source of the booking. */
  source: BookingSource;
  /** Supplementary items attached to this booking. */
  supplementaryItems?: InputMaybe<Array<InputMaybe<SupplementaryItemInput>>>;
  /** Transfer requests associated with this booking. */
  transfers?: InputMaybe<Array<InputMaybe<TransferRequestInput>>>;
};

/** Command to created a new lead. */
export type CreateLeadInput = {
  /** Start date they are interested in. */
  arrivalDate?: InputMaybe<Scalars['String']['input']>;
  /** End date they are interested in. */
  departureDate?: InputMaybe<Scalars['String']['input']>;
  /** Guests for the lead. */
  guests?: InputMaybe<Array<InputMaybe<GuestLeadInput>>>;
  /** Email address or phone of the customer lead. */
  leadContact: Scalars['String']['input'];
  /** Secondary contact (e.g., email if phone is primary). */
  leadContactSecondary?: InputMaybe<Scalars['String']['input']>;
  /** Type of contact the lead prefers - email or phone. */
  leadContactType: LeadContactType;
  /** Name of the customer lead. */
  leadName: Scalars['String']['input'];
  /** Initial notes for the lead (e.g., accommodation preference, message). */
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Optional offering slugs to automatically add as lead items. Each will be matched to an offering by slug and date range. */
  offeringSlugs?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Source of the lead. */
  source: LeadSource;
  /** Optional supplementary items (e.g., additional beds). */
  supplementaryItems?: InputMaybe<Array<InputMaybe<SupplementaryItemInput>>>;
};

/** Create a new package. */
export type CreatePackageInput = {
  /** {@link Package.availableFromDate} */
  availableFromDate: Scalars['String']['input'];
  /** {@link Package.availableUntilDate} */
  availableUntilDate: Scalars['String']['input'];
  /** {@link Package.description} */
  description: Scalars['String']['input'];
  /** {@link Package.name} */
  name: Scalars['String']['input'];
  /** IDs of the offerings that customers can choose from. */
  offerings: Array<InputMaybe<Scalars['String']['input']>>;
  /** {@link Package.slug} */
  slug: Scalars['String']['input'];
  /** Items included with this package. */
  supplementaryItems?: InputMaybe<Array<InputMaybe<SupplementaryItemInput>>>;
};

/** Adds a room offering to an existing workspace. */
export type CreateRoomOfferingInput = {
  /** {@link RoomOffering.availableFromDate} */
  availableFromDate: Scalars['String']['input'];
  /** {@link RoomOffering.availableUntilDate} */
  availableUntilDate: Scalars['String']['input'];
  /** {@link RoomOffering.capacity} */
  capacity: Scalars['Int']['input'];
  /** {@link RoomOffering.description} */
  description: Scalars['String']['input'];
  /** {@link RoomOffering.inventory} */
  inventory: Scalars['Int']['input'];
  /** {@link RoomOffering.name} */
  name: Scalars['String']['input'];
  /** {@link PricingStrategy.pricing} */
  pricing: Array<InputMaybe<PricingStrategyInput>>;
  /** {@link RoomOffering.slug} */
  slug: Scalars['String']['input'];
};

/** Command to create a new team. */
export type CreateTeamInput = {
  /** Main contact person name. */
  contactName: Scalars['String']['input'];
  /** Contact email for the team. */
  email: Scalars['String']['input'];
  /** Display name of the team. */
  name: Scalars['String']['input'];
  /** Contact phone for the team. */
  phoneNumber: Scalars['String']['input'];
  /** Type of team. */
  type: TeamType;
  /** Team website. */
  url: Scalars['String']['input'];
  /** Workspaces this team has access to. */
  workspaces: Array<InputMaybe<Scalars['String']['input']>>;
};

/** Creates a staff member for a team. Returns credentials that should only be shown once. */
export type CreateTeamStaffInput = {
  /** Email of the staff member (used as username). */
  email: Scalars['String']['input'];
  /** Name of the staff member. */
  name: Scalars['String']['input'];
  /** Role of this staff member. For partner teams, this is always AGENT regardless of input. */
  role: Role;
  /** The team this staff member belongs to. */
  team: Scalars['String']['input'];
};

/** Creates a workspace which can be administered via Nivaas. */
export type CreateWorkspaceInput = {
  /** {@link Workspace.displayName} */
  displayName: Scalars['String']['input'];
  /** {@link Workspace.emailAddress} */
  emailAddress: Scalars['String']['input'];
  /** {@link Workspace.name} */
  name: Scalars['String']['input'];
  /** {@link Workspace.namespace} */
  namespace: Scalars['String']['input'];
  /** {@link Workspace.url} */
  url: Scalars['String']['input'];
};

/** Currency a price is presented in. */
export enum Currency {
  /** Indian Rupee. */
  Inr = 'INR',
  /** United States Dollar. */
  Usd = 'USD'
}

/** Represents an external customer, who is able to book residencies in Nivaas. */
export type Customer = Identifiable & Traceable & {
  __typename?: 'Customer';
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** Bookings made by this customer */
  bookingsConnection?: Maybe<CustomerBookingsConnection>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** Email address of the customer */
  email?: Maybe<Scalars['String']['output']>;
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Full name of the customer */
  name: Scalars['String']['output'];
  /** Phone number of the customer */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Quality of data representing this customer. */
  quality: DataQuality;
  /** Status of the customer - verified or not. */
  status: CustomerStatus;
  /** Type of customer - domestic or international. */
  type: CustomerType;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};


/** Represents an external customer, who is able to book residencies in Nivaas. */
export type CustomerBookingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Connection between Customer and bookings */
export type CustomerBookingsConnection = {
  __typename?: 'CustomerBookingsConnection';
  edges?: Maybe<Array<Maybe<CustomerBookingsEdge>>>;
  pageInfo: CustomerBookingsPageInfo;
};

/** Edge between Customer and bookings */
export type CustomerBookingsEdge = {
  __typename?: 'CustomerBookingsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Booking>;
};

/** Page info for connection between Customer and bookings */
export type CustomerBookingsPageInfo = {
  __typename?: 'CustomerBookingsPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

/** Represents an external customer lead, who is interested in to booking with Nivaas. */
export type CustomerLead = {
  __typename?: 'CustomerLead';
  /** Email address of the customer */
  email?: Maybe<Scalars['String']['output']>;
  /** Full name of the customer */
  name: Scalars['String']['output'];
  /** Phone number of the customer */
  phoneNumber?: Maybe<Scalars['String']['output']>;
};

/** Represents the status of a customer. */
export enum CustomerStatus {
  /** Customer has not been verified yet. */
  Unverified = 'UNVERIFIED',
  /** Customer has been verified. */
  Verified = 'VERIFIED'
}

/** Represents the type of customer - domestic or international. */
export enum CustomerType {
  /** Customer is domestic. */
  Domestic = 'DOMESTIC',
  /** Customer is international. */
  International = 'INTERNATIONAL',
  /** Unknown customer type. */
  Unknown = 'UNKNOWN'
}

/** Represents the quality of data representing a customer. */
export enum DataQuality {
  /** Data representing a customer is completely filled. */
  Complete = 'COMPLETE',
  /** Data representing a customer is not compeltely filled yet. */
  Incomplete = 'INCOMPLETE'
}

/** Deactivates a staff member (soft delete). */
export type DeactivateStaffInput = {
  /** The staff member's ID. */
  id: Scalars['ID']['input'];
};

/** Delete a package. */
export type DeletePackageInput = {
  /** ID reference to the package. */
  package: Scalars['String']['input'];
};

/** Command to delete a transfer request. */
export type DeleteTransferRequestInput = {
  /** ID of the transfer request to delete. */
  transfer: Scalars['String']['input'];
};

/** Types of extras that can be added to a room offering. */
export enum ExtraType {
  /** Additional bed added to the room. */
  AdditionalBed = 'ADDITIONAL_BED'
}

/** Represents gender of a guest. */
export enum Gender {
  /** Female */
  Female = 'FEMALE',
  /** Male */
  Male = 'MALE',
  /** Unspecified */
  None = 'NONE',
  /** Non-binary */
  NonBinary = 'NON_BINARY',
  /** Prefer not to disclose to Nivaas */
  PreferNotToSay = 'PREFER_NOT_TO_SAY'
}

/** Query to fetch an agent by ID. */
export type GetAgentByIdInput = {
  /** ID of the agent to fetch. */
  id: Scalars['ID']['input'];
};

/** Query to get agent ledger summary. */
export type GetAgentLedgerSummaryInput = {
  /** ID of the agent. Optional - defaults to current agent if called by an agent. */
  agent?: InputMaybe<Scalars['String']['input']>;
};

/** Get a single booking. */
export type GetBookingByExternalReferenceInput = {
  /** External reference of the booking to retrieve. */
  externalReference: Scalars['String']['input'];
};

/** Get a single booking. */
export type GetBookingByReferenceInput = {
  /** Reference of the booking to retrieve. */
  reference: Scalars['String']['input'];
};

/** Get a single booking. */
export type GetBookingInput = {
  /** ID of the booking to retrieve. */
  booking: Scalars['String']['input'];
};

/** Get a single lead by ID. */
export type GetLeadInput = {
  /** ID of the lead to retrieve. */
  leadId: Scalars['String']['input'];
};

/** Get a specific package by ID. */
export type GetPackageInput = {
  /** ID reference to the package. */
  package: Scalars['String']['input'];
};

/** Lookup a reservation by its ID */
export type GetReservationByIdInput = {
  /** ID of the reservation to update. */
  reservation: Scalars['String']['input'];
};

/** Gets a staff member by their id */
export type GetStaffByIdInput = {
  /** {@link Staff.id} */
  id: Scalars['ID']['input'];
};

/** Query to fetch a team by ID. */
export type GetTeamByIdInput = {
  /** ID of the team to fetch. */
  id: Scalars['ID']['input'];
};

/** Grants define part of a scope. */
export enum Grant {
  /** Granting the ability to perform all actions on a resource. */
  All = 'ALL',
  /** Granting the ability to create a resource. */
  Create = 'CREATE',
  /** Granting the ability to delete a resource. */
  Delete = 'DELETE',
  /** Granting the ability to read a resource. */
  Read = 'READ',
  /** Granting the ability to update a resource. */
  Update = 'UPDATE'
}

/** Command to grant workspace access to an agent. Only adds new access, does not remove existing access. */
export type GrantAgentWorkspaceAccessInput = {
  /** ID of the agent. */
  id: Scalars['ID']['input'];
  /** Workspace IDs to grant access to. */
  workspaces: Array<InputMaybe<Scalars['String']['input']>>;
};

/** Represents a guest who is part of a booking owned by a primary contact (an instance of a customer). */
export type Guest = Identifiable & Traceable & {
  __typename?: 'Guest';
  /** Age of the guest, needed for compliance and data purposes. */
  age: Scalars['Int']['output'];
  /** Attribution of the guest - whether they are an adult or child. */
  attribution: GuestKind;
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** Customer this guest is associated with. */
  customer: Customer;
  /** Optional email address of the guest. */
  email?: Maybe<Scalars['String']['output']>;
  /** Full name of the guest. */
  fullName: Scalars['String']['output'];
  /** Gender of the guest, needed to tune their experience. */
  gender: Gender;
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Optional phone number of the guest. */
  phoneNumber?: Maybe<Scalars['String']['output']>;
  /** Status of the guest. */
  status: GuestStatus;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** Data required to create a new guest. */
export type GuestInput = {
  /** Age of the guest, needed for compliance and data purposes. */
  age: Scalars['Int']['input'];
  /** Attribution of the guest - whether they are an adult or child. */
  attribution: GuestKind;
  /** Optional email address of the guest. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the guest. */
  fullName: Scalars['String']['input'];
  /** Gender of the guest, needed to tune their experience. */
  gender: Gender;
  /** An optional ID of the guest. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Optional phone number of the guest. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Represents whether a guest is an adult or child. */
export enum GuestKind {
  /** Adult */
  Adult = 'ADULT',
  /** Child */
  Child = 'CHILD'
}

/** Represents a guest who is part of a lead made by a primary contact. */
export type GuestLead = {
  __typename?: 'GuestLead';
  /** Age of the guest, needed for compliance and data purposes. */
  age?: Maybe<Scalars['Int']['output']>;
  /** Attribution of the guest - whether they are an adult or child. */
  attribution?: Maybe<GuestKind>;
  /** Full name of the guest. */
  fullName: Scalars['String']['output'];
  /** Gender of the guest, needed to tune their experience. */
  gender?: Maybe<Gender>;
};

/** Data required to create a new guest. */
export type GuestLeadInput = {
  /** Age of the guest, needed for compliance and data purposes. */
  age?: InputMaybe<Scalars['Int']['input']>;
  /** Attribution of the guest - whether they are an adult or child. */
  attribution?: InputMaybe<GuestKind>;
  /** Full name of the guest. */
  fullName: Scalars['String']['input'];
  /** Gender of the guest, needed to tune their experience. */
  gender?: InputMaybe<Gender>;
};

/** Data related to guest updates on a booking */
export type GuestPatchInput = {
  /** New data to associate with a the booking. */
  added?: InputMaybe<Array<InputMaybe<GuestInput>>>;
  /** IDs to remove from the booking. */
  removed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Existing data to associate with a booking. */
  updated?: InputMaybe<Array<InputMaybe<GuestInput>>>;
};

/** Represents the status of a guest. */
export enum GuestStatus {
  /** Guest has not been verified via ID yet. */
  Unverified = 'UNVERIFIED',
  /** Guest has been verified via ID. */
  Verified = 'VERIFIED'
}

/** An identifiable entity has a unique identifier, or ID. */
export type Identifiable = {
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
};

/** The entry structure for current available inventory. */
export type InventoryEntry = {
  __typename?: 'InventoryEntry';
  /** Number of availability. */
  available: Scalars['Int']['output'];
  /** The key for this entry - looks like `date:room`. */
  id: Scalars['ID']['output'];
};

/** The entry structure for current available inventory. */
export type InventoryEntryVerbose = {
  __typename?: 'InventoryEntryVerbose';
  /** List of available room IDs. */
  availableRoomIds: Array<Maybe<Scalars['String']['output']>>;
  /** The key for this entry - looks like `date:room`. */
  id: Scalars['ID']['output'];
  /** Number of inventory. */
  inventory: Scalars['Int']['output'];
  /** Number of pax. */
  pax: Scalars['Int']['output'];
  /** Number of taken. */
  taken: Scalars['Int']['output'];
};

/** An invoice which a customer must pay for to succeed in booking. */
export type Invoice = Identifiable & Traceable & {
  __typename?: 'Invoice';
  /** Amount earned from this invoice by the operator. */
  amountEarned: Scalars['Float']['output'];
  /** Amount owed to Nivaas by the agent for this invoice. Only non-zero for agent bookings (amountEarned + gstIncurred). For non-agent bookings, this will be 0. */
  amountOwed: Scalars['Float']['output'];
  /** Amount remaining to be paid on this invoice. */
  amountRemaining: Scalars['Float']['output'];
  /** Attachments associated with this invoice. */
  attachments: Array<Maybe<Attachment>>;
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** Customer responsible for paying this invoice. */
  customer: Customer;
  /** Price after GST. */
  grossPrice: Scalars['Float']['output'];
  /** Price component of GST. */
  gstIncurred: Scalars['Float']['output'];
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** List of items on this invoice. */
  items: Array<Maybe<InvoiceItem>>;
  /** Price before GST. */
  netPrice: Scalars['Float']['output'];
  /** Additional notes or context regarding this invoice. */
  note?: Maybe<Scalars['String']['output']>;
  /** Payments made to satisfy this invoice. */
  payments: Array<Maybe<Payment>>;
  /** Status of this invoice. */
  status: InvoiceStatus;
  /** Supplementary items on this invoice. */
  supplementaryItems: Array<Maybe<SupplementaryItem>>;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** Data required to create a new invoice. */
export type InvoiceInput = {
  /** List of items on this invoice. */
  items: Array<InputMaybe<InvoiceItemInput>>;
  /** Payment made for this booking. */
  payment?: InputMaybe<PaymentInput>;
};

/** Represents a single item on an invoice. */
export type InvoiceItem = {
  __typename?: 'InvoiceItem';
  /** Discount applied to this item. */
  discount?: Maybe<Scalars['Float']['output']>;
  /** GST to apply on this item. */
  gst: Scalars['Int']['output'];
  /** Offering being paid for. */
  offering: RoomOffering;
  /** Quantity of this item being paid for. */
  quantity: Scalars['Int']['output'];
  /** Price per item. */
  unitPrice: Price;
};

/** Represents a single item on an invoice. */
export type InvoiceItemInput = {
  /** Discount applied to this item. */
  discount?: InputMaybe<Scalars['Int']['input']>;
  /** GST applied on this item. */
  gst: Scalars['Int']['input'];
  /** Offering being paid for. */
  offering: Scalars['String']['input'];
  /** Quantity being paid for. */
  quantity: Scalars['Int']['input'];
  /** Price per item. */
  unitPrice: PriceInput;
};

/** Status of an invoice */
export enum InvoiceStatus {
  /** Invoice has been cancelled and superseded. */
  Cancelled = 'CANCELLED',
  /** Invoice has been fully paid. */
  FullyPaid = 'FULLY_PAID',
  /** Invoice has been partially paid. */
  PartiallyPaid = 'PARTIALLY_PAID',
  /** Invoice has not been paid yet. */
  Pending = 'PENDING'
}

/** Compact summary of an invoice, including high-level pricing information. */
export type InvoiceSummary = {
  __typename?: 'InvoiceSummary';
  /** Amount earned by the operator after agent commission deduction. When no agent is associated, equals netPrice. */
  amountEarned?: Maybe<Scalars['Float']['output']>;
  /** Price after GST. */
  grossPrice: Scalars['Float']['output'];
  /** Price before GST. */
  netPrice: Scalars['Float']['output'];
};

/** Represents a customer lead. A lead is a potential customer who has shown interest in certain offerings. */
export type Lead = Identifiable & Traceable & {
  __typename?: 'Lead';
  /** Start date of the booking. */
  arrivalDate?: Maybe<Scalars['String']['output']>;
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** Details regarding the lead. */
  customer: CustomerLead;
  /** End date of the booking. */
  departureDate?: Maybe<Scalars['String']['output']>;
  /** Guests associated with the lead. */
  guests?: Maybe<Array<Maybe<GuestLead>>>;
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Offerings they are interested in. */
  items: Array<Maybe<LeadItem>>;
  /** Optional notes on the lead. */
  notes: Array<Maybe<Scalars['String']['output']>>;
  /** Source of the lead. */
  source: LeadSource;
  /** Current status of the lead. */
  status: LeadStatus;
  /** Optional supplementary items (e.g., additional beds). */
  supplementaryItems?: Maybe<Array<Maybe<SupplementaryItem>>>;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** Preferred contact method for a lead. */
export enum LeadContactType {
  /** Contact type for email. */
  Email = 'EMAIL',
  /** Contact type for phone. */
  Phone = 'PHONE'
}

/** Represents a single booking item. */
export type LeadItem = {
  __typename?: 'LeadItem';
  /** The offering being booked. */
  offering: RoomOffering;
  /** Quantity of an offering being booked. */
  quantity: Scalars['Int']['output'];
};

/** Source of a lead. */
export enum LeadSource {
  /** The lead was produced through an offline, internal source - phone, cold-call, etc. */
  Offline = 'OFFLINE',
  /** The lead was produced online. */
  Online = 'ONLINE'
}

/** Current status of a lead. Used to determine areas to invest further. */
export enum LeadStatus {
  /** Lead has been cancelled. */
  Cancelled = 'CANCELLED',
  /** Lead has been converted into a booking. */
  Converted = 'CONVERTED',
  /** Lead is waiting for input from customer to proceed. */
  WaitingForCustomer = 'WAITING_FOR_CUSTOMER',
  /** Lead is waiting for support from a Nivaas staff member. */
  WaitingForSupport = 'WAITING_FOR_SUPPORT'
}

/** Query to list agent payments. */
export type ListAgentPaymentsInput = {
  /** ID of the agent. Optional - defaults to current agent if called by an agent. */
  agent?: InputMaybe<Scalars['String']['input']>;
};

/** Query to list agents with access to the current workspace. Note: Workspace filtering is automatic based on request context. */
export type ListAgentsInput = {
  /** Filter agents by name (optional). */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Gives back a global list of all rooms. */
export type ListAllRoomsInput = {
  /** Optional name filter for rooms. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Finds offerings available over a time range. */
export type ListAvailableRoomOfferingsInput = {
  /** The start date of the offering. */
  fromDate: Scalars['String']['input'];
  /** The end date of the offering. */
  toDate: Scalars['String']['input'];
};

/** List all bookings. */
export type ListBookingsInput = {
  /** Optional start date to filter to. */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Optional filter for bookings by customer name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional end date to filter to. */
  toDate?: InputMaybe<Scalars['String']['input']>;
};

/** Query to list customers. */
export type ListCustomersInput = {
  /** Optional name to filter customers by. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Provides a structure which can allow you to map between `date:room` and `available`. */
export type ListInventoryItemsInput = {
  /** Optional name filter. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Provides a verbose structure (Map<string, [number, number, number, string[]]>) which maps between `date:room` and `[taken, inventory, pax, availableRoomIds]`. To map appropriately with graphql, returns as the entries list. */
export type ListInventoryItemsVerboseInput = {
  /** Optional name filter. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** List all leads. */
export type ListLeadsInput = {
  /** Optional start date to filter from. */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Optional filter for leads by customer lead name. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional end date to filter to. */
  toDate?: InputMaybe<Scalars['String']['input']>;
};

/** List all packages available in the workspace. */
export type ListPackagesInput = {
  /** Optional date filter - returns packages available on this date. */
  availableOn?: InputMaybe<Scalars['String']['input']>;
  /** Whether to include inactive packages. Defaults to false (only active). */
  includeInactive?: InputMaybe<Scalars['Boolean']['input']>;
  /** Optional name filter for packages (partial match). */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Optional offering filter - returns packages that allow this offering. */
  offering?: InputMaybe<Scalars['String']['input']>;
  /** Optional slug filter for packages (exact match). */
  slug?: InputMaybe<Scalars['String']['input']>;
};

/** List all reservations. */
export type ListReservationsInput = {
  /** Optional date to start from. */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Optional filter for allocations by status. */
  status?: InputMaybe<ReservationStatus>;
  /** Optional date to end at. */
  toDate?: InputMaybe<Scalars['String']['input']>;
};

/** List dates a room offering is available. */
export type ListRoomOfferingsAvailabilityInput = {
  /** The offering being queried. */
  roomOffering: Scalars['String']['input'];
};

/** Dates an offering is available. */
export type ListRoomOfferingsAvailabilityQueryResponse = {
  __typename?: 'ListRoomOfferingsAvailabilityQueryResponse';
  /** Dates the offering is available. */
  availableDates: Array<Maybe<Scalars['String']['output']>>;
};

/** List all offerings available in a namespace. */
export type ListRoomOfferingsInput = {
  /** Optional name filter for offerings. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Finds a rooms based upon a time range and type. */
export type ListRoomsInput = {
  /** The start date of the offering. */
  fromDate: Scalars['String']['input'];
  /** The type of offering to find. */
  roomOffering?: InputMaybe<Scalars['String']['input']>;
  /** The end date of the offering. */
  toDate: Scalars['String']['input'];
};

/** List all staff. */
export type ListStaffInput = {
  /** Optional filter for staff by name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Lists staff members for a specific team. */
export type ListTeamStaffInput = {
  /** The team ID to list staff for. */
  team: Scalars['String']['input'];
};

/** Query to list transfers. */
export type ListTransfersInput = {
  /** Optional start date to filter to. */
  fromDate?: InputMaybe<Scalars['String']['input']>;
  /** Optional end date to filter to. */
  toDate?: InputMaybe<Scalars['String']['input']>;
};

/** List all workspaces */
export type ListWorkspacesInput = {
  /** Optional filter for workspaces by name. */
  name?: InputMaybe<Scalars['String']['input']>;
};

/** Login as staff. */
export type LoginStaffInput = {
  /** {@link Staff.email} */
  email: Scalars['String']['input'];
  /** {@link Staff.password} */
  password: Scalars['String']['input'];
};

/** Command for marking all notifications as read. */
export type MarkAllNotificationsAsReadInput = {
  /** Placeholder parameter (not used, but required for GraphQL input type). */
  _placeholder?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Result of marking all notifications as read. */
export type MarkAllNotificationsAsReadResult = {
  __typename?: 'MarkAllNotificationsAsReadResult';
  /** The number of notifications that were marked as read. */
  count: Scalars['Int']['output'];
};

/** Command for marking a notification as read. */
export type MarkNotificationAsReadInput = {
  /** The ID of the notification to mark as read. */
  notificationId: Scalars['String']['input'];
};

export type Mutation = {
  __typename?: 'Mutation';
  addGuestToLead?: Maybe<Lead>;
  addItemToLead?: Maybe<Lead>;
  addPayment?: Maybe<Booking>;
  addPricingStrategy?: Maybe<RoomOffering>;
  addSupplementaryItem?: Maybe<Booking>;
  addTransferRequest?: Maybe<TransferRequest>;
  attachFileToInvoice?: Maybe<Invoice>;
  authenticateStaff?: Maybe<Scalars['Boolean']['output']>;
  calculateBookingPrice?: Maybe<InvoiceSummary>;
  cancelBooking?: Maybe<Booking>;
  cancelBookings?: Maybe<Array<Maybe<Booking>>>;
  cancelLead?: Maybe<Lead>;
  confirmAgentPayment?: Maybe<AgentPayment>;
  convertLead?: Maybe<Booking>;
  createAgent?: Maybe<Agent>;
  createAgentPayment?: Maybe<AgentPayment>;
  createBooking?: Maybe<Booking>;
  createLead?: Maybe<Lead>;
  createPackage?: Maybe<Package>;
  createRoomOffering?: Maybe<RoomOffering>;
  createTeam?: Maybe<Team>;
  createTeamStaff?: Maybe<StaffWithCredentials>;
  createWorkspace?: Maybe<Workspace>;
  deactivateStaff?: Maybe<Scalars['Boolean']['output']>;
  deletePackage?: Maybe<Scalars['Boolean']['output']>;
  deleteTransferRequest?: Maybe<Scalars['Boolean']['output']>;
  grantAgentWorkspaceAccess?: Maybe<Agent>;
  loginStaff?: Maybe<StaffProtected>;
  markAllNotificationsAsRead?: Maybe<MarkAllNotificationsAsReadResult>;
  markNotificationAsRead?: Maybe<Notification>;
  purgeInactiveRooms?: Maybe<PurgeInactiveRoomsResult>;
  rejectAgentPayment?: Maybe<AgentPayment>;
  removeGuestFromLead?: Maybe<Lead>;
  removeItemFromLead?: Maybe<Lead>;
  removePayment?: Maybe<Booking>;
  removePricingStrategy?: Maybe<RoomOffering>;
  removeSupplementaryItem?: Maybe<Booking>;
  resetStaffPassword?: Maybe<StaffWithCredentials>;
  settleAgentBooking?: Maybe<Booking>;
  unsettleAgentBooking?: Maybe<Booking>;
  updateAgent?: Maybe<Agent>;
  updateBooking?: Maybe<Booking>;
  updateCustomer?: Maybe<Customer>;
  updateGuest?: Maybe<Guest>;
  updateGuestLead?: Maybe<Lead>;
  updateLead?: Maybe<Lead>;
  updateLeadStatus?: Maybe<Lead>;
  updatePackage?: Maybe<Package>;
  updatePayment?: Maybe<Payment>;
  updateReservationReferences?: Maybe<Reservation>;
  updateReservationStatus?: Maybe<Reservation>;
  updateRoomOfferingAvailability?: Maybe<RoomOffering>;
  updateRoomOfferingCapacity?: Maybe<RoomOffering>;
  updateRoomOfferingExtras?: Maybe<RoomOffering>;
  updateRoomOfferingInventory?: Maybe<RoomOffering>;
  updateRoomOfferingPrice?: Maybe<RoomOffering>;
  updateStaffRole?: Maybe<StaffProtected>;
  updateSupplementaryItem?: Maybe<Booking>;
  updateTransferRequest?: Maybe<TransferRequest>;
};


export type MutationAddGuestToLeadArgs = {
  input: AddGuestToLeadInput;
};


export type MutationAddItemToLeadArgs = {
  input: AddItemToLeadInput;
};


export type MutationAddPaymentArgs = {
  input: AddPaymentInput;
};


export type MutationAddPricingStrategyArgs = {
  input: AddPricingStrategyInput;
};


export type MutationAddSupplementaryItemArgs = {
  input: AddSupplementaryItemInput;
};


export type MutationAddTransferRequestArgs = {
  input: AddTransferRequestInput;
};


export type MutationAttachFileToInvoiceArgs = {
  input: AttachFileToInvoiceInput;
};


export type MutationAuthenticateStaffArgs = {
  input: AuthenticateStaffInput;
};


export type MutationCalculateBookingPriceArgs = {
  input: CalculateBookingPriceInput;
};


export type MutationCancelBookingArgs = {
  input: CancelBookingInput;
};


export type MutationCancelBookingsArgs = {
  input: CancelBookingsInput;
};


export type MutationCancelLeadArgs = {
  input: CancelLeadInput;
};


export type MutationConfirmAgentPaymentArgs = {
  input: ConfirmAgentPaymentInput;
};


export type MutationConvertLeadArgs = {
  input: ConvertLeadInput;
};


export type MutationCreateAgentArgs = {
  input: CreateAgentInput;
};


export type MutationCreateAgentPaymentArgs = {
  input: CreateAgentPaymentInput;
};


export type MutationCreateBookingArgs = {
  input: CreateBookingInput;
};


export type MutationCreateLeadArgs = {
  input: CreateLeadInput;
};


export type MutationCreatePackageArgs = {
  input: CreatePackageInput;
};


export type MutationCreateRoomOfferingArgs = {
  input: CreateRoomOfferingInput;
};


export type MutationCreateTeamArgs = {
  input: CreateTeamInput;
};


export type MutationCreateTeamStaffArgs = {
  input: CreateTeamStaffInput;
};


export type MutationCreateWorkspaceArgs = {
  input: CreateWorkspaceInput;
};


export type MutationDeactivateStaffArgs = {
  input: DeactivateStaffInput;
};


export type MutationDeletePackageArgs = {
  input: DeletePackageInput;
};


export type MutationDeleteTransferRequestArgs = {
  input: DeleteTransferRequestInput;
};


export type MutationGrantAgentWorkspaceAccessArgs = {
  input: GrantAgentWorkspaceAccessInput;
};


export type MutationLoginStaffArgs = {
  input: LoginStaffInput;
};


export type MutationMarkAllNotificationsAsReadArgs = {
  input: MarkAllNotificationsAsReadInput;
};


export type MutationMarkNotificationAsReadArgs = {
  input: MarkNotificationAsReadInput;
};


export type MutationPurgeInactiveRoomsArgs = {
  input: PurgeInactiveRoomsInput;
};


export type MutationRejectAgentPaymentArgs = {
  input: RejectAgentPaymentInput;
};


export type MutationRemoveGuestFromLeadArgs = {
  input: RemoveGuestFromLeadInput;
};


export type MutationRemoveItemFromLeadArgs = {
  input: RemoveItemFromLeadInput;
};


export type MutationRemovePaymentArgs = {
  input: RemovePaymentInput;
};


export type MutationRemovePricingStrategyArgs = {
  input: RemovePricingStrategyInput;
};


export type MutationRemoveSupplementaryItemArgs = {
  input: RemoveSupplementaryItemInput;
};


export type MutationResetStaffPasswordArgs = {
  input: ResetStaffPasswordInput;
};


export type MutationSettleAgentBookingArgs = {
  input: SettleAgentBookingInput;
};


export type MutationUnsettleAgentBookingArgs = {
  input: UnsettleAgentBookingInput;
};


export type MutationUpdateAgentArgs = {
  input: UpdateAgentInput;
};


export type MutationUpdateBookingArgs = {
  input: UpdateBookingInput;
};


export type MutationUpdateCustomerArgs = {
  input: UpdateCustomerInput;
};


export type MutationUpdateGuestArgs = {
  input: UpdateGuestInput;
};


export type MutationUpdateGuestLeadArgs = {
  input: UpdateGuestLeadInput;
};


export type MutationUpdateLeadArgs = {
  input: UpdateLeadInput;
};


export type MutationUpdateLeadStatusArgs = {
  input: UpdateLeadStatusInput;
};


export type MutationUpdatePackageArgs = {
  input: UpdatePackageInput;
};


export type MutationUpdatePaymentArgs = {
  input: UpdatePaymentInput;
};


export type MutationUpdateReservationReferencesArgs = {
  input: UpdateReservationReferencesInput;
};


export type MutationUpdateReservationStatusArgs = {
  input: UpdateReservationStatusInput;
};


export type MutationUpdateRoomOfferingAvailabilityArgs = {
  input: UpdateRoomOfferingAvailabilityInput;
};


export type MutationUpdateRoomOfferingCapacityArgs = {
  input: UpdateRoomOfferingCapacityInput;
};


export type MutationUpdateRoomOfferingExtrasArgs = {
  input: UpdateRoomOfferingExtrasInput;
};


export type MutationUpdateRoomOfferingInventoryArgs = {
  input: UpdateRoomOfferingInventoryInput;
};


export type MutationUpdateRoomOfferingPriceArgs = {
  input: UpdateRoomOfferingPriceInput;
};


export type MutationUpdateStaffRoleArgs = {
  input: UpdateStaffRoleInput;
};


export type MutationUpdateSupplementaryItemArgs = {
  input: UpdateSupplementaryItemInput;
};


export type MutationUpdateTransferRequestArgs = {
  input: UpdateTransferRequestInput;
};

/** Query input for fetching the current user's notifications. */
export type MyNotificationsInput = {
  /** Maximum number of notifications to return. */
  limit?: InputMaybe<Scalars['Int']['input']>;
};

/** Result of my notifications query. */
export type MyNotificationsResult = {
  __typename?: 'MyNotificationsResult';
  /** The list of notifications. */
  notifications: Array<Maybe<Notification>>;
  /** The count of unread notifications. */
  unreadCount: Scalars['Int']['output'];
};

/** Query to fetch a single entity by its ID. Uses NivaasIdentifier format to determine entity type. */
export type NodeInput = {
  /** The full NivaasIdentifier of the entity to fetch. */
  id: Scalars['ID']['input'];
};

/** Query to fetch multiple entities by their IDs. Uses NivaasIdentifier format to determine entity types. */
export type NodesInput = {
  /** The full NivaasIdentifiers of the entities to fetch. */
  ids: Array<InputMaybe<Scalars['String']['input']>>;
};

/** An in-app notification for a user. Workspace can be derived from the id using NivaasIdentifier.namespace(). Entity type can be derived from entityId using NivaasIdentifier.type(). */
export type Notification = Identifiable & Traceable & {
  __typename?: 'Notification';
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The notification body text. */
  body: Scalars['String']['output'];
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** The full NivaasIdentifier of the entity this notification relates to. */
  entityId?: Maybe<Scalars['String']['output']>;
  /** The ID of the event that triggered this notification. */
  eventId?: Maybe<Scalars['String']['output']>;
  /** A key used for client-side batching of similar notifications. */
  groupKey?: Maybe<Scalars['String']['output']>;
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** The kind of notification (e.g., 'booking/created'). */
  notificationType: Scalars['String']['output'];
  /** Whether the notification has been read. */
  read: Scalars['Boolean']['output'];
  /** The timestamp when this notification was read. */
  readAt?: Maybe<Scalars['Float']['output']>;
  /** The user who should receive this notification. */
  recipient: StaffPublic;
  /** The notification title. */
  title: Scalars['String']['output'];
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** Represents a configurable extra for a room offering. */
export type OfferingExtra = {
  __typename?: 'OfferingExtra';
  /** GST percentage applied to this extra. */
  gst: Scalars['Int']['output'];
  /** Maximum quantity per room. */
  maxQuantityPerRoom?: Maybe<Scalars['Int']['output']>;
  /** Display name. */
  name: Scalars['String']['output'];
  /** Price of the extra per night. */
  price: Price;
  /** Type of extra. */
  type: ExtraType;
};

/** Data required to define an offering extra. */
export type OfferingExtraInput = {
  /** GST percentage applied to this extra. */
  gst: Scalars['Int']['input'];
  /** Maximum quantity per room. */
  maxQuantityPerRoom?: InputMaybe<Scalars['Int']['input']>;
  /** Display name. */
  name: Scalars['String']['input'];
  /** Price of the extra per night. */
  price: PriceInput;
  /** Type of extra. */
  type: ExtraType;
};

/** An operator team manages site operations. */
export type OperatorTeam = Identifiable & Team & {
  __typename?: 'OperatorTeam';
  /** Main contact person name. */
  contactName: Scalars['String']['output'];
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** Contact email for the team. */
  email: Scalars['String']['output'];
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Display name of the team. */
  name: Scalars['String']['output'];
  /** Contact phone for the team. */
  phoneNumber: Scalars['String']['output'];
  /** Operator teams are always of type OPERATOR. */
  type: TeamType;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
  /** Team website. */
  url: Scalars['String']['output'];
  /** Workspaces this team has access to. Staff members inherit workspace access from their team. */
  workspaces: Array<Maybe<Workspace>>;
};

/** Represents a package that bundles offerings with supplementary items. Customers can select from allowed offerings, and supplementary items are automatically included when the package is booked.  Packages are immutable once bookings reference them. When a package is updated, the old version is marked inactive and a new version is created. This ensures bookings always reference the exact package configuration that was active at booking time.  Package names must be unique among active packages. Multiple inactive packages can share a name (representing version history). Frontend can group packages by name and sort by createdAt to display version history. */
export type Package = Identifiable & Traceable & {
  __typename?: 'Package';
  /** Offerings that customers can choose from when booking this package. */
  allowedOfferings: Array<Maybe<RoomOffering>>;
  /** Start date from which this package is available. */
  availableFromDate: Scalars['String']['output'];
  /** End date when this package is no longer available. */
  availableUntilDate: Scalars['String']['output'];
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** Description of this package. */
  description: Scalars['String']['output'];
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Whether this package is currently active and available for new bookings. Inactive packages are archived versions that may still be referenced by existing bookings. */
  isActive: Scalars['Boolean']['output'];
  /** Name of this package. Must be unique among active packages. */
  name: Scalars['String']['output'];
  /** Unique, human-readable identifier for this package. */
  slug: Scalars['String']['output'];
  /** Items included with this package (meals, transport, etc.). These are locked when the package is booked. */
  supplementaryItems?: Maybe<Array<Maybe<SupplementaryItem>>>;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** A payment performed by a customer for a booking. */
export type Payment = Identifiable & Traceable & {
  __typename?: 'Payment';
  /** Amount being paid on this payment. */
  amountPaid: Price;
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Additional notes or context regarding this payment. */
  note?: Maybe<Scalars['String']['output']>;
  /** The payment provider used for this booking. */
  provider: PaymentProvider;
  /** Reference of the payment. */
  reference?: Maybe<Scalars['String']['output']>;
  /** The current status of a payment. */
  status: PaymentStatus;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** Data required to create a new payment. */
export type PaymentInput = {
  /** Amount being paid on this payment. */
  amountPaid: PriceInput;
  /** Optional ID of the payment. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Additional notes or context regarding this payment. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** Provider used for the payment. */
  provider: PaymentProvider;
  /** Payment reference for the payment. */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** Current status of the payment. */
  status: PaymentStatus;
};

/** Data related to payment updates on a booking */
export type PaymentPatchInput = {
  /** New data to associate with a the booking. */
  added?: InputMaybe<Array<InputMaybe<PaymentInput>>>;
  /** IDs to remove from the booking. */
  removed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Existing data to associate with a booking. */
  updated?: InputMaybe<Array<InputMaybe<PaymentInput>>>;
};

/** Supported payment providers of Nivaas. */
export enum PaymentProvider {
  /** For local payments (India). */
  BankTransfer = 'BANK_TRANSFER',
  /** For in-person payments on arrival. */
  InPerson = 'IN_PERSON',
  /** Unspecified payment provider. */
  None = 'NONE',
  /** For international payments. */
  Paypal = 'PAYPAL',
  /** For local payments (India). */
  Razorpay = 'RAZORPAY'
}

/** Status of a customer payment. */
export enum PaymentStatus {
  /** Payment failed. */
  Failed = 'FAILED',
  /** Payment is pending. */
  Pending = 'PENDING',
  /** Payment succeeded. */
  Success = 'SUCCESS'
}

/** A definition of which Scopes and associated Grants a Permission entails. */
export type Permission = {
  __typename?: 'Permission';
  /** The grant of the permission. */
  grant: Grant;
  /** The qualifier of the permission. Represents the 'space' of entities which a principal is granted the ability 'act' on in a system. Example values: '*' for all, 'me' for only entities which are tied to, or owned by a user. */
  qualifier: Qualifier;
  /** The scope of the permission. */
  scope: Scope;
};

/** Represents a price in a specific currency. */
export type Price = {
  __typename?: 'Price';
  /** The amount of money. */
  amount: Scalars['Float']['output'];
  /** The currency of the money. */
  currency: Currency;
};

/** Represents a price in a specific currency for API input. */
export type PriceInput = {
  /** The amount of money. */
  amount: Scalars['Float']['input'];
  /** The currency of the money. */
  currency: Currency;
};

/** Represents the pricing strategy for a specific offering. */
export type PricingStrategy = {
  __typename?: 'PricingStrategy';
  /** Start date from which this pricing is applicable. */
  applicableFromDate: Scalars['String']['output'];
  /** Specific dates this pricing is applicable. */
  applicableOnDates?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** Date this pricing was applicable until. */
  applicableUntilDate?: Maybe<Scalars['String']['output']>;
  /** GST to apply on this pricing. */
  gst: Scalars['Int']['output'];
  /** Unit price to be applied. */
  unitPrice: Price;
};

/** Data required to define a pricing strategy. */
export type PricingStrategyInput = {
  /** Start date from which this pricing is applicable. */
  applicableFromDate: Scalars['String']['input'];
  /** Specific dates this pricing is applicable. */
  applicableOnDates?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Date this pricing was applicable until. */
  applicableUntilDate?: InputMaybe<Scalars['String']['input']>;
  /** GST to apply on this pricing. */
  gst: Scalars['Int']['input'];
  /** Base price to be applied. */
  unitPrice: PriceInput;
};

/** Permanently deletes all inactive rooms from an offering. Use this to clean up rooms that were marked INACTIVE during inventory reduction. This operation is destructive and cannot be undone. */
export type PurgeInactiveRoomsInput = {
  /** Dry run the operation to preview what would be deleted. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID reference to the room offering. */
  offering: Scalars['String']['input'];
};

/** Result of purging inactive rooms. */
export type PurgeInactiveRoomsResult = {
  __typename?: 'PurgeInactiveRoomsResult';
  /** Number of rooms that were deleted. */
  purgedCount: Scalars['Int']['output'];
  /** IDs of the rooms that were deleted. */
  purgedRoomIds: Array<Maybe<Scalars['String']['output']>>;
};

/** The space of entities which a person has access to within a permission 'space'. Aligns with data scopes: global data uses ALL, containerized data uses CONTAINER. */
export enum Qualifier {
  /** Can access global data + all containers. Used for operators/admins. */
  All = 'ALL',
  /** Can only access own container (team's data). Used for partners/agents. Maps to scope: 'container' with belongsTo.id filtering. */
  Container = 'CONTAINER',
  /** Can only access self (own team/agent profile). Used for agents reading their own data. */
  Me = 'ME'
}

export type Query = {
  __typename?: 'Query';
  activityForEntity?: Maybe<Array<Maybe<ActivityEntry>>>;
  canSettleBooking?: Maybe<CanSettleBookingResult>;
  getAgentById?: Maybe<Agent>;
  getAgentLedgerSummary?: Maybe<AgentLedgerSummary>;
  getBooking?: Maybe<Booking>;
  getBookingByExternalReference?: Maybe<Booking>;
  getBookingByReference?: Maybe<Booking>;
  getLead?: Maybe<Lead>;
  getPackage?: Maybe<Package>;
  getReservationById?: Maybe<Reservation>;
  getStaffById?: Maybe<StaffPublic>;
  getTeamById?: Maybe<Team>;
  listAgentPayments?: Maybe<Array<Maybe<AgentPayment>>>;
  listAgents?: Maybe<Array<Maybe<Agent>>>;
  listAllRooms?: Maybe<Array<Maybe<Room>>>;
  listAvailableRoomOfferings?: Maybe<Array<Maybe<RoomOffering>>>;
  listBookings?: Maybe<Array<Maybe<Booking>>>;
  listCustomers?: Maybe<Array<Maybe<Customer>>>;
  listInventoryItems?: Maybe<Array<Maybe<InventoryEntry>>>;
  listInventoryItemsVerbose?: Maybe<Array<Maybe<InventoryEntryVerbose>>>;
  listLeads?: Maybe<Array<Maybe<Lead>>>;
  listPackages?: Maybe<Array<Maybe<Package>>>;
  listReservations?: Maybe<Array<Maybe<Reservation>>>;
  listRoomOfferings?: Maybe<Array<Maybe<RoomOffering>>>;
  listRoomOfferingsAvailability?: Maybe<ListRoomOfferingsAvailabilityQueryResponse>;
  listRooms?: Maybe<Array<Maybe<Room>>>;
  listStaff?: Maybe<Array<Maybe<StaffProtected>>>;
  listTeamStaff?: Maybe<Array<Maybe<StaffProtected>>>;
  listTransfers?: Maybe<Array<Maybe<TransferRequest>>>;
  listWorkspaces?: Maybe<Array<Maybe<Workspace>>>;
  myNotifications?: Maybe<MyNotificationsResult>;
  node?: Maybe<Identifiable>;
  nodes?: Maybe<Array<Maybe<Identifiable>>>;
  unreadNotificationCount?: Maybe<Scalars['Int']['output']>;
};


export type QueryActivityForEntityArgs = {
  input: ActivityForEntityInput;
};


export type QueryCanSettleBookingArgs = {
  input: CanSettleBookingInput;
};


export type QueryGetAgentByIdArgs = {
  input: GetAgentByIdInput;
};


export type QueryGetAgentLedgerSummaryArgs = {
  input: GetAgentLedgerSummaryInput;
};


export type QueryGetBookingArgs = {
  input: GetBookingInput;
};


export type QueryGetBookingByExternalReferenceArgs = {
  input: GetBookingByExternalReferenceInput;
};


export type QueryGetBookingByReferenceArgs = {
  input: GetBookingByReferenceInput;
};


export type QueryGetLeadArgs = {
  input: GetLeadInput;
};


export type QueryGetPackageArgs = {
  input: GetPackageInput;
};


export type QueryGetReservationByIdArgs = {
  input: GetReservationByIdInput;
};


export type QueryGetStaffByIdArgs = {
  input: GetStaffByIdInput;
};


export type QueryGetTeamByIdArgs = {
  input: GetTeamByIdInput;
};


export type QueryListAgentPaymentsArgs = {
  input: ListAgentPaymentsInput;
};


export type QueryListAgentsArgs = {
  input: ListAgentsInput;
};


export type QueryListAllRoomsArgs = {
  input: ListAllRoomsInput;
};


export type QueryListAvailableRoomOfferingsArgs = {
  input: ListAvailableRoomOfferingsInput;
};


export type QueryListBookingsArgs = {
  input: ListBookingsInput;
};


export type QueryListCustomersArgs = {
  input: ListCustomersInput;
};


export type QueryListInventoryItemsArgs = {
  input: ListInventoryItemsInput;
};


export type QueryListInventoryItemsVerboseArgs = {
  input: ListInventoryItemsVerboseInput;
};


export type QueryListLeadsArgs = {
  input: ListLeadsInput;
};


export type QueryListPackagesArgs = {
  input: ListPackagesInput;
};


export type QueryListReservationsArgs = {
  input: ListReservationsInput;
};


export type QueryListRoomOfferingsArgs = {
  input: ListRoomOfferingsInput;
};


export type QueryListRoomOfferingsAvailabilityArgs = {
  input: ListRoomOfferingsAvailabilityInput;
};


export type QueryListRoomsArgs = {
  input: ListRoomsInput;
};


export type QueryListStaffArgs = {
  input: ListStaffInput;
};


export type QueryListTeamStaffArgs = {
  input: ListTeamStaffInput;
};


export type QueryListTransfersArgs = {
  input: ListTransfersInput;
};


export type QueryListWorkspacesArgs = {
  input: ListWorkspacesInput;
};


export type QueryMyNotificationsArgs = {
  input: MyNotificationsInput;
};


export type QueryNodeArgs = {
  input: NodeInput;
};


export type QueryNodesArgs = {
  input: NodesInput;
};


export type QueryUnreadNotificationCountArgs = {
  input: UnreadNotificationCountInput;
};

/** Command to reject an agent payment (by operator). */
export type RejectAgentPaymentInput = {
  /** ID of the payment to reject. */
  payment: Scalars['String']['input'];
  /** Reason for rejection. */
  reason?: InputMaybe<Scalars['String']['input']>;
};

/** Represents a connection between two entities. */
export type Relationship = {
  /** The nodes which the current entity is being related to. */
  entities: Array<Maybe<Identifiable>>;
  /** The type of relationship. */
  type: RelationshipType;
};

/** The types of relationships supported. Each of these are related to key design principles when modelling data schemas. */
export enum RelationshipType {
  /** Represents if entity B is part of A, and can exist independently of A. */
  AggregatedBy = 'AGGREGATED_BY',
  /** Represents if entity B uses A, and can exist independently of A. */
  AssociatedWith = 'ASSOCIATED_WITH',
  /** Represents if some entity B is part of A, and cannot exist without A. */
  ComposedOf = 'COMPOSED_OF'
}

/** Command to remove a guest from a lead. */
export type RemoveGuestFromLeadInput = {
  /** ID of the guest to remove. */
  guestId: Scalars['Int']['input'];
  /** ID of the lead to remote the guest from. */
  id: Scalars['ID']['input'];
};

/** Command to remove an item from a lead. */
export type RemoveItemFromLeadInput = {
  /** ID of the lead to remove the item from. */
  leadId: Scalars['String']['input'];
  /** ID of the offering to remove. */
  offeringId: Scalars['String']['input'];
  /** Quantity of offerings to remove. */
  quantity: Scalars['Int']['input'];
};

/** Command to attach a payment to a booking. */
export type RemovePaymentInput = {
  /** ID of the booking to attach the payment to. */
  booking: Scalars['String']['input'];
  /** Payment to remove from a booking. */
  payment: Scalars['String']['input'];
};

/** Command to remove a pricing strategy from an offering. Only allowed if there is more than one pricing strategy and no existing bookings. */
export type RemovePricingStrategyInput = {
  /** Index of the pricing strategy to remove. */
  pricingIndex: Scalars['Int']['input'];
  /** ID reference to the room offering. */
  roomOffering: Scalars['String']['input'];
};

/** Command to remove a supplementary item. */
export type RemoveSupplementaryItemInput = {
  /** ID of the booking to remove the supplementary item from. */
  booking: Scalars['String']['input'];
  /** ID of the supplementary item to remove. */
  item: Scalars['Int']['input'];
};

/** The result of a booking, allocating a room to a customer. */
export type Reservation = Identifiable & Traceable & {
  __typename?: 'Reservation';
  /** Date the reservation starts. */
  arrivalDate: Scalars['String']['output'];
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The booking this allocation references. */
  booking: Booking;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** The customer this reservation is for. */
  customer: Customer;
  /** Date the reservation ends. */
  departureDate: Scalars['String']['output'];
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** The distinct items which make up this reservation. */
  items: Array<Maybe<ReservationItem>>;
  /** The current status of this allocation. */
  status: ReservationStatus;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** Represents one of the rooms reserved for a customer to satisfy a booking. */
export type ReservationItem = {
  __typename?: 'ReservationItem';
  /** Day to start from - 1-indexed. */
  fromDay?: Maybe<Scalars['Int']['output']>;
  /** The physical room number which has been allocated. */
  reference?: Maybe<Scalars['String']['output']>;
  /** The physical room number(s) which has been allocated. */
  references?: Maybe<Array<Maybe<Scalars['String']['output']>>>;
  /** The room reserved for the customer. */
  room: Room;
  /** Day to end at - 1-indexed. */
  toDay?: Maybe<Scalars['Int']['output']>;
};

/** Reference to a reservation item. */
export type ReservationItemReferenceInput = {
  /** ID of the reservation item. */
  id: Scalars['ID']['input'];
  /** The physical room number which has been allocated. */
  reference: Scalars['String']['input'];
  /** The physical room number(s) which has been allocated. */
  references: Array<InputMaybe<Scalars['String']['input']>>;
};

/** Status of a reservation. */
export enum ReservationStatus {
  /** Allocation has been booked. */
  Booked = 'BOOKED',
  /** Allocation was cancelled, etc. */
  Cancelled = 'CANCELLED',
  /** Allocation is active - customer is currently present. */
  CheckedIn = 'CHECKED_IN',
  /** Allocation has been fulfilled - customer has left. */
  CheckedOut = 'CHECKED_OUT',
  /** An unallocated reservation which requires manual intervention. */
  Unallocated = 'UNALLOCATED',
  /** Allocation was not fulfilled - due to cancellation, no-show, etc. */
  Unfulfilled = 'UNFULFILLED'
}

/** Resets a staff member's password. */
export type ResetStaffPasswordInput = {
  /** The staff member's ID. */
  id: Scalars['ID']['input'];
};

/** The supported roles of the Nivaas application. */
export enum Role {
  /** An admin. Able to administer the entire application. */
  Admin = 'ADMIN',
  /** An Agent. Only able to read inventory available. */
  Agent = 'AGENT',
  /** An Agent Admin. Like an agent, but can also manage staff within their own team. */
  AgentAdmin = 'AGENT_ADMIN',
  /** An admin. Able to administer the entire application. */
  HelpDesk = 'HELP_DESK',
  /** Reception. Only able to write to reservation statuses. */
  Reception = 'RECEPTION',
  /** An admin. Able to administer the entire application and create other users. */
  SuperAdmin = 'SUPER_ADMIN',
  /** Viewer. Only able to read all resources. */
  Viewer = 'VIEWER'
}

/** An room provided in the inventory. */
export type Room = Identifiable & Traceable & {
  __typename?: 'Room';
  /** Date this room is available from. */
  availableFromDate: Scalars['String']['output'];
  /** Date this room is available until. */
  availableUntilDate: Scalars['String']['output'];
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Backlink to the offering this room is part of. */
  offering: RoomOffering;
  /** Date slots available for booking. */
  slots: Array<Maybe<Scalars['String']['output']>>;
  /** Status of this room. */
  status?: Maybe<RoomStatus>;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** Represents a room offering part of a workspace. */
export type RoomOffering = Identifiable & Traceable & {
  __typename?: 'RoomOffering';
  /** Start date from which this offering is provided. */
  availableFromDate: Scalars['String']['output'];
  /** End date when this offering is no longer provided after. */
  availableUntilDate: Scalars['String']['output'];
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** Number of people this offering can accommodate. */
  capacity: Scalars['Int']['output'];
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** Description of this offering. */
  description: Scalars['String']['output'];
  /** Configurable extras available for this offering. */
  extras?: Maybe<Array<Maybe<OfferingExtra>>>;
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Total inventory for this offering. */
  inventory: Scalars['Int']['output'];
  /** Name of this offering. */
  name: Scalars['String']['output'];
  /** Pricing information for this workspace offering. */
  pricing: Array<Maybe<PricingStrategy>>;
  /** Rooms in this offering. */
  roomsConnection?: Maybe<RoomOfferingRoomsConnection>;
  /** Unique, human-readable identifier for this offering. */
  slug: Scalars['String']['output'];
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};


/** Represents a room offering part of a workspace. */
export type RoomOfferingRoomsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Connection between RoomOffering and rooms */
export type RoomOfferingRoomsConnection = {
  __typename?: 'RoomOfferingRoomsConnection';
  edges?: Maybe<Array<Maybe<RoomOfferingRoomsEdge>>>;
  pageInfo: RoomOfferingRoomsPageInfo;
};

/** Edge between RoomOffering and rooms */
export type RoomOfferingRoomsEdge = {
  __typename?: 'RoomOfferingRoomsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<Room>;
};

/** Page info for connection between RoomOffering and rooms */
export type RoomOfferingRoomsPageInfo = {
  __typename?: 'RoomOfferingRoomsPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

/** Represents the status of a room. */
export enum RoomStatus {
  /** Room is active and available for bookings. */
  Active = 'ACTIVE',
  /** Room is inactive and maintains its previous data. */
  Inactive = 'INACTIVE'
}

/** The Scopes which a user has access to. */
export enum Scope {
  /** Activity history entries for entities. */
  Activity = 'ACTIVITY',
  /** Agents capable of making bookings for customers. */
  Agent = 'AGENT',
  /** Payments made by agents to the Nivaas platform. */
  AgentPayment = 'AGENT_PAYMENT',
  /** A booking made by a customer. */
  Booking = 'BOOKING',
  /** A customer who is able to make bookings. */
  Customer = 'CUSTOMER',
  /** A guest attached to a customer. */
  Guest = 'GUEST',
  /** Availability data of nivaas inventory today. */
  Inventory = 'INVENTORY',
  /** An invoice which needs to be satisfied by a customer through payments. */
  Invoice = 'INVOICE',
  /** A lead that is either auto-configured or manually configured, representing a potential customer. */
  Lead = 'LEAD',
  /** In-app notifications for users. */
  Notification = 'NOTIFICATION',
  /** Extras that can be added to a room offering. */
  OfferingExtra = 'OFFERING_EXTRA',
  /** Packages that bundle offerings with supplementary items. */
  Package = 'PACKAGE',
  /** A payment made by a customer to satisfy an invoice. */
  Payment = 'PAYMENT',
  /** Reservations made to satisfy a booking. */
  Reservation = 'RESERVATION',
  /** Instances of a room offering. */
  Room = 'ROOM',
  /** A room offering provided by a workspace. */
  RoomOffering = 'ROOM_OFFERING',
  /** A staff member, who is able to manipulate resources for a provider of Nivaas. */
  Staff = 'STAFF',
  /** Teams that group staff members and own data. */
  Team = 'TEAM',
  /** A transfer request for a customer. */
  Transfer = 'TRANSFER',
  /** A workspace which plugs into Nivaas. */
  Workspace = 'WORKSPACE'
}

/** Command to settle an agent booking (marks it as paid to Nivaas). Agent must have sufficient available credit to settle the booking. */
export type SettleAgentBookingInput = {
  /** ID of the booking to settle. */
  booking: Scalars['String']['input'];
};

/** A staff member who has access to Nivaas, without sensitive data. */
export type StaffProtected = Identifiable & Traceable & {
  __typename?: 'StaffProtected';
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** The email of this employee. */
  email: Scalars['String']['output'];
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** The name of this employee. */
  name: Scalars['String']['output'];
  /** Role of this staff member. Applies to all workspaces the team has access to. */
  role: Role;
  /** Status of the staff member (active or inactive). */
  status?: Maybe<StaffStatus>;
  /** The team this staff member belongs to. Workspace access is inherited from the team. */
  team: Team;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** A staff member who has access to Nivaas, only with public-facing data. */
export type StaffPublic = Identifiable & {
  __typename?: 'StaffPublic';
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** The name of this employee. */
  name: Scalars['String']['output'];
};

/** A staff member who has access to Nivaas. */
export type StaffSensitive = Identifiable & Traceable & {
  __typename?: 'StaffSensitive';
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** The email of this employee. Indexed as 'email' to avoid collisions with other entity types. */
  email: Scalars['String']['output'];
  /** Encryption key unique to this employee. */
  encryptionKey: Scalars['String']['output'];
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** The name of this employee. */
  name: Scalars['String']['output'];
  /** The hashed password of this employee. */
  password: Scalars['String']['output'];
  /** Role of this staff member. Applies to all workspaces the team has access to. */
  role: Role;
  /** Status of this staff member. */
  status?: Maybe<StaffStatus>;
  /** The team this staff member belongs to. Workspace access is inherited from the team. */
  team: Team;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** Status of a staff member. */
export enum StaffStatus {
  /** Staff member is active. */
  Active = 'ACTIVE',
  /** Staff member is inactive */
  Inactive = 'INACTIVE'
}

/** Staff member with credentials - only returned on creation or password reset. The password should NEVER be stored or returned after initial display. */
export type StaffWithCredentials = {
  __typename?: 'StaffWithCredentials';
  /** The staff member's email (used as username). */
  email: Scalars['String']['output'];
  /** The staff member's ID. */
  id: Scalars['ID']['output'];
  /** The staff member's name. */
  name: Scalars['String']['output'];
  /** The plaintext password - ONLY shown once on creation/reset. */
  password: Scalars['String']['output'];
  /** The team ID this staff member belongs to. Used for sending email notifications with team context. */
  team?: Maybe<Scalars['String']['output']>;
};

/** Represents a supplementary item on an invoice. */
export type SupplementaryItem = {
  __typename?: 'SupplementaryItem';
  /** Optional discount applied to this item. */
  discount?: Maybe<Scalars['Int']['output']>;
  /** GST applied on this item. */
  gst: Scalars['Int']['output'];
  /** If true, this item came from a package and cannot be removed. */
  lockedFromPackage?: Maybe<Scalars['Boolean']['output']>;
  /** Name of the supplementary item. */
  name: Scalars['String']['output'];
  /** Price of the supplementary item. */
  price: Price;
  /** Quantity of the supplementary item. */
  quantity: Scalars['Int']['output'];
};

/** Data required to create a new supplementary item. */
export type SupplementaryItemInput = {
  /** Optional discount applied to this item. */
  discount?: InputMaybe<Scalars['Int']['input']>;
  /** GST applied on this item. */
  gst: Scalars['Int']['input'];
  /** Optional index of the supplementary item. */
  index?: InputMaybe<Scalars['Int']['input']>;
  /** Name of the supplementary item. */
  name: Scalars['String']['input'];
  /** Price of the supplementary item. */
  price: PriceInput;
  /** Quantity of the supplementary item. */
  quantity: Scalars['Int']['input'];
};

/** Data related to supplementary item updates on a booking */
export type SupplementaryItemPatchInput = {
  /** New data to associate with a the booking. */
  added?: InputMaybe<Array<InputMaybe<SupplementaryItemInput>>>;
  /** IDs to remove from the booking. */
  removed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Existing data to associate with a booking. */
  updated?: InputMaybe<Array<InputMaybe<SupplementaryItemInput>>>;
};

/** A team groups staff members and owns data. */
export type Team = {
  /** Main contact person name. */
  contactName: Scalars['String']['output'];
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** Contact email for the team. */
  email: Scalars['String']['output'];
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Display name of the team. */
  name: Scalars['String']['output'];
  /** Contact phone for the team. */
  phoneNumber: Scalars['String']['output'];
  /** Type of team - determines access scope. */
  type: TeamType;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
  /** Team website. */
  url: Scalars['String']['output'];
  /** Workspaces this team has access to. Staff members inherit workspace access from their team. */
  workspaces: Array<Maybe<Workspace>>;
};

/** Type of team - determines data access scope and hierarchy.  Hierarchy: - OPERATOR: Site operations team (e.g., Camp67 staff) - can see ALL bookings             for their workspaces and administer partners - PARTNER: External agency (e.g., travel agents) - isolated to their own            bookings only, administered by operators */
export enum TeamType {
  /** Site operations team - manages physical properties. Can see all bookings for their workspaces and administer partner relationships. */
  Operator = 'OPERATOR',
  /** External partner (travel agent, booking agency). Isolated to their own team's data. Administered by operators. */
  Partner = 'PARTNER'
}

/** A traceable entity has a lifecycle defined over time. */
export type Traceable = {
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** Represents a customer request to transfer to & from a Nivaas residence. */
export type TransferRequest = Identifiable & Traceable & {
  __typename?: 'TransferRequest';
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** Reservation this request is associated with. */
  booking: Booking;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** Customer who made this request. */
  customer: Customer;
  /** Details about the transfer. */
  details?: Maybe<Scalars['String']['output']>;
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** Location to end the transfer. */
  location: Scalars['String']['output'];
  /** Date of the transfer request. */
  scheduledAt: Scalars['String']['output'];
  /** Time of the transfer request. */
  scheduledTime: Scalars['String']['output'];
  /** Status of the transport request. */
  status: TransferStatus;
  /** Type of transfer request. */
  type: TransferType;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
};

/** Data required to create a new transfer request. */
export type TransferRequestInput = {
  /** Details about the transfer. */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Optional ID of the transfer request. */
  id?: InputMaybe<Scalars['ID']['input']>;
  /** Location to end the transfer. */
  location: Scalars['String']['input'];
  /** Date of the transfer request. */
  scheduledAt: Scalars['String']['input'];
  /** Time of the transfer request. */
  scheduledTime: Scalars['String']['input'];
  /** Type of transfer request. */
  type: TransferType;
};

/** Data related to transfer request updates on a booking */
export type TransferRequestPatchInput = {
  /** New data to associate with a the booking. */
  added?: InputMaybe<Array<InputMaybe<TransferRequestInput>>>;
  /** IDs to remove from the booking. */
  removed?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Existing data to associate with a booking. */
  updated?: InputMaybe<Array<InputMaybe<TransferRequestInput>>>;
};

/** Status of the transfer request. */
export enum TransferStatus {
  /** Request has been cancelled. */
  Cancelled = 'CANCELLED',
  /** Request has been completed. */
  Completed = 'COMPLETED',
  /** Request has been raised. */
  Requested = 'REQUESTED'
}

/** Type of transport request. */
export enum TransferType {
  /** Drop request. */
  Drop = 'DROP',
  /** Pickup request. */
  Pickup = 'PICKUP'
}

/** Query input for getting the count of unread notifications. */
export type UnreadNotificationCountInput = {
  /** Placeholder parameter (not used, but required for GraphQL input type). */
  _placeholder?: InputMaybe<Scalars['Boolean']['input']>;
};

/** Command to unsettle an agent booking (operator only). Reverts the settlement status and frees up the allocated credit. */
export type UnsettleAgentBookingInput = {
  /** ID of the booking to unsettle. */
  booking: Scalars['String']['input'];
};

/** Command to update an agent. */
export type UpdateAgentInput = {
  /** Commissions for this agent. */
  commissions?: InputMaybe<Array<InputMaybe<AgentCommissionInput>>>;
  /** Name of main contact person. */
  contactName?: InputMaybe<Scalars['String']['input']>;
  /** Email address on which this agent can be reached. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** ID of the agent to update. */
  id: Scalars['ID']['input'];
  /** Name of the agent company. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the agent. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Website of the agent. */
  url?: InputMaybe<Scalars['String']['input']>;
  /** Workspaces this agent has access to. */
  workspaces?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
};

/** Command to update a booking. */
export type UpdateBookingInput = {
  /** Agent associated with this booking. */
  agent?: InputMaybe<Scalars['String']['input']>;
  /** Change to arrival date. */
  arrivalDate?: InputMaybe<Scalars['String']['input']>;
  /** ID of the booking to update. */
  booking: Scalars['String']['input'];
  /** Change to departure date. */
  departureDate?: InputMaybe<Scalars['String']['input']>;
  /** Experiences attached to this booking. */
  experiences?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Guest updates for this booking. */
  guests?: InputMaybe<GuestPatchInput>;
  /** Instructions attached to this booking. */
  instructions?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Item updates for this booking. */
  items?: InputMaybe<Array<InputMaybe<BookingItemInput>>>;
  /** Notes attached to this booking. */
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Payment updates for this booking. */
  payments?: InputMaybe<PaymentPatchInput>;
  /** Source of the booking. */
  source?: InputMaybe<BookingSource>;
  /** Supplementary item updates for this booking. */
  supplementaryItems?: InputMaybe<SupplementaryItemPatchInput>;
  /** Transfer updates for this booking. */
  transfers?: InputMaybe<TransferRequestPatchInput>;
};

/** Command to update a new customer. */
export type UpdateCustomerInput = {
  /** ID of the customer to update. */
  customer: Scalars['String']['input'];
  /** Email address of the customer */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the customer */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Phone number of the customer */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
  /** Type of the customer */
  type?: InputMaybe<CustomerType>;
};

/** Command to update the details attached to a guest. */
export type UpdateGuestInput = {
  /** Age of the guest, needed for compliance and data purposes. */
  age?: InputMaybe<Scalars['Int']['input']>;
  /** Attribution of the guest - whether they are an adult or child. */
  attribution?: InputMaybe<GuestKind>;
  /** Optional email address of the guest. */
  email?: InputMaybe<Scalars['String']['input']>;
  /** Full name of the guest. */
  fullName?: InputMaybe<Scalars['String']['input']>;
  /** Gender of the guest, needed to tune their experience. */
  gender?: InputMaybe<Gender>;
  /** ID of the guest to update. */
  guest: Scalars['String']['input'];
  /** Optional phone number of the guest. */
  phoneNumber?: InputMaybe<Scalars['String']['input']>;
};

/** Command to add a guest to a lead. */
export type UpdateGuestLeadInput = {
  /** Guest to add to the lead. */
  guest: GuestLeadInput;
  /** ID of the guest to update. */
  guestId: Scalars['Int']['input'];
  /** ID of the lead to add the guest to. */
  id: Scalars['ID']['input'];
};

/** Command to update a new lead. */
export type UpdateLeadInput = {
  /** Start date they are interested in. */
  arrivalDate?: InputMaybe<Scalars['String']['input']>;
  /** End date they are interested in. */
  departureDate?: InputMaybe<Scalars['String']['input']>;
  /** ID of the lead to update. */
  id: Scalars['ID']['input'];
  /** Email address or phone of the customer lead. */
  leadContact?: InputMaybe<Scalars['String']['input']>;
  /** Type of contact the lead prefers - email or phone. */
  leadContactType?: InputMaybe<LeadContactType>;
  /** Name of the customer lead. */
  leadName?: InputMaybe<Scalars['String']['input']>;
  /** Notes to add to the lead. New notes are appended to existing notes. */
  notes?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** Source of the lead. */
  source?: InputMaybe<LeadSource>;
};

/** Command to update the status of a lead. */
export type UpdateLeadStatusInput = {
  /** ID of the lead to remove the item from. */
  leadId: Scalars['String']['input'];
  /** Latest lead status. */
  status: LeadStatus;
};

/** Update an existing package. */
export type UpdatePackageInput = {
  /** {@link Package.availableFromDate} */
  availableFromDate?: InputMaybe<Scalars['String']['input']>;
  /** {@link Package.availableUntilDate} */
  availableUntilDate?: InputMaybe<Scalars['String']['input']>;
  /** {@link Package.description} */
  description?: InputMaybe<Scalars['String']['input']>;
  /** {@link Package.name} */
  name?: InputMaybe<Scalars['String']['input']>;
  /** IDs of the offerings that customers can choose from. */
  offerings?: InputMaybe<Array<InputMaybe<Scalars['String']['input']>>>;
  /** ID reference to the package. */
  package: Scalars['String']['input'];
  /** {@link Package.slug} */
  slug?: InputMaybe<Scalars['String']['input']>;
  /** Items included with this package. */
  supplementaryItems?: InputMaybe<Array<InputMaybe<SupplementaryItemInput>>>;
};

/** Command to update a payment. */
export type UpdatePaymentInput = {
  /** The new amount paid of the payment. */
  amountPaid?: InputMaybe<PriceInput>;
  /** Booking the payment belongs to. */
  booking: Scalars['String']['input'];
  /** Update a note on the payment. */
  note?: InputMaybe<Scalars['String']['input']>;
  /** The payment to update. */
  payment: Scalars['String']['input'];
  /** Provider of the payment. */
  provider?: InputMaybe<PaymentProvider>;
  /** Reference of the payment. */
  reference?: InputMaybe<Scalars['String']['input']>;
  /** The new status of the payment. */
  status?: InputMaybe<PaymentStatus>;
};

/** Update the references inside each reservation item. */
export type UpdateReservationReferencesInput = {
  /** Each of the references for each reservation item. */
  references: Array<InputMaybe<ReservationItemReferenceInput>>;
  /** ID of the reservation to update. */
  reservation: Scalars['String']['input'];
};

/** Update the status of a reservation. */
export type UpdateReservationStatusInput = {
  /** ID of the reservation to update. */
  reservation: Scalars['String']['input'];
  /** New status of the reservation. */
  status: ReservationStatus;
};

/** Extend availability dates for a room offering. Only allows extending the range (earlier start or later end), never shrinking. Updates the offering and all its rooms, including their availability masks. */
export type UpdateRoomOfferingAvailabilityInput = {
  /** New start date. Must be same or earlier than current availableFromDate. */
  availableFromDate?: InputMaybe<Scalars['String']['input']>;
  /** New end date. Must be same or later than current availableUntilDate. */
  availableUntilDate?: InputMaybe<Scalars['String']['input']>;
  /** Dry run the operation to preview changes. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** ID reference to the room offering. */
  offering: Scalars['String']['input'];
};

/** Update capacity of an offering. */
export type UpdateRoomOfferingCapacityInput = {
  /** Capacity to update to. */
  capacity: Scalars['Int']['input'];
  /** ID reference to the room offering. */
  offering: Scalars['String']['input'];
};

/** Command to update extras configuration for a room offering. */
export type UpdateRoomOfferingExtrasInput = {
  /** The complete list of extras for this offering. Replaces the existing extras configuration. */
  extras: Array<InputMaybe<OfferingExtraInput>>;
  /** ID reference to the room offering. */
  roomOffering: Scalars['String']['input'];
};

/** Update a room offering. */
export type UpdateRoomOfferingInventoryInput = {
  /** Dry run the operation. */
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
  /** Inventory to update to. */
  inventory: Scalars['Int']['input'];
  /** ID reference to the room offering. */
  offering: Scalars['String']['input'];
};

/** Update pricing strategy of an offering. */
export type UpdateRoomOfferingPriceInput = {
  /** Start date when this pricing is applicable. */
  applicableFromDate?: InputMaybe<Scalars['String']['input']>;
  /** End date when this pricing is applicable. */
  applicableUntilDate?: InputMaybe<Scalars['String']['input']>;
  /** GST to update to. */
  gst?: InputMaybe<Scalars['Int']['input']>;
  /** ID reference to the room offering. */
  offering: Scalars['String']['input'];
  /** ID of the pricing strategy to update */
  pricing: Scalars['Int']['input'];
  /** Unit price to update to. */
  unitPrice?: InputMaybe<PriceInput>;
};

/** Updates a staff member's role. For partner teams, only AGENT or AGENT_ADMIN are valid. */
export type UpdateStaffRoleInput = {
  /** The staff member's ID. */
  id: Scalars['ID']['input'];
  /** The new role for the staff member. */
  role: Role;
};

/** Command to update a supplementary item. */
export type UpdateSupplementaryItemInput = {
  /** ID of the booking to update the supplementary item on. */
  booking: Scalars['String']['input'];
  /** Optional discount applied to this item. */
  discount?: InputMaybe<Scalars['Int']['input']>;
  /** GST applied on this item. */
  gst?: InputMaybe<Scalars['Int']['input']>;
  /** ID of the supplementary item to update. */
  item: Scalars['Int']['input'];
  /** Name of the supplementary item. */
  name?: InputMaybe<Scalars['String']['input']>;
  /** Price of the supplementary item. */
  price?: InputMaybe<PriceInput>;
  /** Quantity of the supplementary item. */
  quantity?: InputMaybe<Scalars['Int']['input']>;
};

/** Command to update a transfer request. */
export type UpdateTransferRequestInput = {
  /** Details about the transfer. */
  details?: InputMaybe<Scalars['String']['input']>;
  /** Location to end the transfer. */
  location?: InputMaybe<Scalars['String']['input']>;
  /** Date of the transfer request. */
  scheduledAt?: InputMaybe<Scalars['String']['input']>;
  /** Time of the transfer request. */
  scheduledTime?: InputMaybe<Scalars['String']['input']>;
  /** Status of the transfer request. */
  status?: InputMaybe<TransferStatus>;
  /** ID of the transfer request to update. */
  transfer: Scalars['String']['input'];
  /** Type of transfer request. */
  type?: InputMaybe<TransferType>;
};

/** Type of vehicle. */
export enum VehicleType {
  /** Transport customer in a car */
  Car = 'CAR',
  /** Transport customer in a shuttle */
  Shuttle = 'SHUTTLE'
}

/** Represents a 'provider' which is hooked into the Nivaas platform. */
export type Workspace = Identifiable & Traceable & {
  __typename?: 'Workspace';
  /** The team this entity belongs to. Used for multi-tenant data isolation. */
  belongsTo?: Maybe<Team>;
  /** The timestamp at which this entity was created. */
  createdAt: Scalars['Float']['output'];
  /** Who this entity was created by. */
  createdBy?: Maybe<StaffPublic>;
  /** Human-readable name for the workspace, for use in staff-facing UIs. */
  displayName: Scalars['String']['output'];
  /** Email address for contacting staff who administer this workspace. */
  emailAddress: Scalars['String']['output'];
  /** The ID - this should be a unique string, or a structured ID (to be defined). */
  id: Scalars['ID']['output'];
  /** A human-readable name for distinguishing this workspace. */
  name: Scalars['String']['output'];
  /** A unique namespace ID for this workspace. */
  namespace: Scalars['String']['output'];
  /** Room offerings unique to this workspace. */
  roomOfferingsConnection?: Maybe<WorkspaceRoomOfferingsConnection>;
  /** The timestamp at which this entity was last updated. */
  updatedAt?: Maybe<Scalars['Float']['output']>;
  /** Who this entity was last updated by. */
  updatedBy?: Maybe<StaffPublic>;
  /** URL to a website representing the workspace. */
  url: Scalars['String']['output'];
};


/** Represents a 'provider' which is hooked into the Nivaas platform. */
export type WorkspaceRoomOfferingsConnectionArgs = {
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
};

/** Connection between Workspace and roomOfferings */
export type WorkspaceRoomOfferingsConnection = {
  __typename?: 'WorkspaceRoomOfferingsConnection';
  edges?: Maybe<Array<Maybe<WorkspaceRoomOfferingsEdge>>>;
  pageInfo: WorkspaceRoomOfferingsPageInfo;
};

/** Edge between Workspace and roomOfferings */
export type WorkspaceRoomOfferingsEdge = {
  __typename?: 'WorkspaceRoomOfferingsEdge';
  cursor: Scalars['String']['output'];
  node?: Maybe<RoomOffering>;
};

/** Page info for connection between Workspace and roomOfferings */
export type WorkspaceRoomOfferingsPageInfo = {
  __typename?: 'WorkspaceRoomOfferingsPageInfo';
  hasNextPage: Scalars['Boolean']['output'];
  hasPreviousPage: Scalars['Boolean']['output'];
};

export type BookingFragmentFragment = { __typename: 'Booking', id: string, status: BookingStatus, arrivalDate: string, reference: string, externalReference?: string | null, departureDate: string, notes: Array<string | null>, experiences?: Array<string | null> | null, instructions: Array<string | null>, source: BookingSource, updatedAt?: number | null, createdAt: number, agent?: { __typename: 'Agent', id: string, name: string } | null, settlement?: { __typename?: 'AgentSettlement', settled: boolean, settledAt: number } | null, createdBy?: { __typename: 'StaffPublic', id: string, name: string } | null, updatedBy?: { __typename: 'StaffPublic', id: string, name: string } | null, invoices: Array<{ __typename: 'Invoice', id: string, status: InvoiceStatus, netPrice: number, grossPrice: number, amountEarned: number, gstIncurred: number, amountOwed: number, amountRemaining: number, payments: Array<{ __typename?: 'Payment', provider: PaymentProvider, status: PaymentStatus, reference?: string | null, id: string, createdAt: number, note?: string | null, amountPaid: { __typename?: 'Price', amount: number, currency: Currency } } | null>, supplementaryItems: Array<{ __typename?: 'SupplementaryItem', name: string, quantity: number, gst: number, discount?: number | null, price: { __typename?: 'Price', amount: number, currency: Currency } } | null> } | null>, transfers: Array<{ __typename: 'TransferRequest', id: string, type: TransferType, location: string, scheduledAt: string, scheduledTime: string, status: TransferStatus, details?: string | null } | null>, reservation?: { __typename: 'Reservation', id: string, status: ReservationStatus, items: Array<{ __typename?: 'ReservationItem', reference?: string | null, references?: Array<string | null> | null, room: { __typename?: 'Room', id: string, offering: { __typename?: 'RoomOffering', slug: string, name: string } } } | null> } | null, customer: { __typename: 'Customer', id: string, name: string, email?: string | null, phoneNumber?: string | null, type: CustomerType, quality: DataQuality }, package?: { __typename: 'Package', id: string, name: string, slug: string, description: string } | null, guests: Array<{ __typename: 'Guest', id: string, fullName: string, attribution: GuestKind, age: number, gender: Gender } | null>, items: Array<{ __typename?: 'BookingItem', quantity: number, discount?: number | null, offering: { __typename: 'RoomOffering', id: string, slug: string, name: string, capacity: number, inventory: number, pricing: Array<{ __typename?: 'PricingStrategy', applicableOnDates?: Array<string | null> | null, unitPrice: { __typename?: 'Price', amount: number } } | null> }, extras?: Array<{ __typename?: 'BookingExtraItem', type: ExtraType, quantity: number } | null> | null } | null>, attachments: Array<{ __typename: 'Attachment', id: string, name: string, size: number, createdAt: number } | null> };

export type AddItemToLeadMutationVariables = Exact<{
  input: AddItemToLeadInput;
}>;


export type AddItemToLeadMutation = { __typename?: 'Mutation', addItemToLead?: { __typename?: 'Lead', id: string, items: Array<{ __typename?: 'LeadItem', quantity: number, offering: { __typename?: 'RoomOffering', id: string, name: string, slug: string } } | null> } | null };

export type AddPaymentMutationVariables = Exact<{
  input: AddPaymentInput;
}>;


export type AddPaymentMutation = { __typename?: 'Mutation', addPayment?: { __typename: 'Booking', id: string } | null };

export type AddSupplementaryItemMutationVariables = Exact<{
  input: AddSupplementaryItemInput;
}>;


export type AddSupplementaryItemMutation = { __typename?: 'Mutation', addSupplementaryItem?: { __typename: 'Booking', id: string } | null };

export type AddTransferRequestMutationVariables = Exact<{
  input: AddTransferRequestInput;
}>;


export type AddTransferRequestMutation = { __typename?: 'Mutation', addTransferRequest?: { __typename: 'TransferRequest', id: string } | null };

export type CalculateBookingPriceMutationVariables = Exact<{
  input: CalculateBookingPriceInput;
}>;


export type CalculateBookingPriceMutation = { __typename?: 'Mutation', calculateBookingPrice?: { __typename?: 'InvoiceSummary', netPrice: number, grossPrice: number } | null };

export type CancelLeadMutationVariables = Exact<{
  input: CancelLeadInput;
}>;


export type CancelLeadMutation = { __typename?: 'Mutation', cancelLead?: { __typename?: 'Lead', id: string, status: LeadStatus, updatedAt?: number | null } | null };

export type ConfirmAgentPaymentMutationVariables = Exact<{
  input: ConfirmAgentPaymentInput;
}>;


export type ConfirmAgentPaymentMutation = { __typename?: 'Mutation', confirmAgentPayment?: { __typename?: 'AgentPayment', id: string, status: AgentPaymentStatus, confirmedAt?: number | null } | null };

export type CreateAgentPaymentMutationVariables = Exact<{
  input: CreateAgentPaymentInput;
}>;


export type CreateAgentPaymentMutation = { __typename?: 'Mutation', createAgentPayment?: { __typename?: 'AgentPayment', id: string, reference: string, note?: string | null, status: AgentPaymentStatus, createdAt: number, amount: { __typename?: 'Price', amount: number, currency: Currency } } | null };

export type CreateAgentMutationVariables = Exact<{
  input: CreateAgentInput;
}>;


export type CreateAgentMutation = { __typename?: 'Mutation', createAgent?: { __typename: 'Agent', id: string, name: string, email: string, phoneNumber: string, contactName: string, url: string, workspaces: Array<{ __typename?: 'Workspace', id: string, name: string } | null>, commissions: Array<{ __typename?: 'AgentCommission', commissionPercentage: number, offering: { __typename?: 'RoomOffering', id: string, name: string } } | null> } | null };

export type CreateBookingMutationVariables = Exact<{
  input: CreateBookingInput;
}>;


export type CreateBookingMutation = { __typename?: 'Mutation', createBooking?: { __typename: 'Booking', id: string, status: BookingStatus, arrivalDate: string, reference: string, externalReference?: string | null, departureDate: string, notes: Array<string | null>, experiences?: Array<string | null> | null, instructions: Array<string | null>, source: BookingSource, updatedAt?: number | null, createdAt: number, agent?: { __typename: 'Agent', id: string, name: string } | null, settlement?: { __typename?: 'AgentSettlement', settled: boolean, settledAt: number } | null, createdBy?: { __typename: 'StaffPublic', id: string, name: string } | null, updatedBy?: { __typename: 'StaffPublic', id: string, name: string } | null, invoices: Array<{ __typename: 'Invoice', id: string, status: InvoiceStatus, netPrice: number, grossPrice: number, amountEarned: number, gstIncurred: number, amountOwed: number, amountRemaining: number, payments: Array<{ __typename?: 'Payment', provider: PaymentProvider, status: PaymentStatus, reference?: string | null, id: string, createdAt: number, note?: string | null, amountPaid: { __typename?: 'Price', amount: number, currency: Currency } } | null>, supplementaryItems: Array<{ __typename?: 'SupplementaryItem', name: string, quantity: number, gst: number, discount?: number | null, price: { __typename?: 'Price', amount: number, currency: Currency } } | null> } | null>, transfers: Array<{ __typename: 'TransferRequest', id: string, type: TransferType, location: string, scheduledAt: string, scheduledTime: string, status: TransferStatus, details?: string | null } | null>, reservation?: { __typename: 'Reservation', id: string, status: ReservationStatus, items: Array<{ __typename?: 'ReservationItem', reference?: string | null, references?: Array<string | null> | null, room: { __typename?: 'Room', id: string, offering: { __typename?: 'RoomOffering', slug: string, name: string } } } | null> } | null, customer: { __typename: 'Customer', id: string, name: string, email?: string | null, phoneNumber?: string | null, type: CustomerType, quality: DataQuality }, package?: { __typename: 'Package', id: string, name: string, slug: string, description: string } | null, guests: Array<{ __typename: 'Guest', id: string, fullName: string, attribution: GuestKind, age: number, gender: Gender } | null>, items: Array<{ __typename?: 'BookingItem', quantity: number, discount?: number | null, offering: { __typename: 'RoomOffering', id: string, slug: string, name: string, capacity: number, inventory: number, pricing: Array<{ __typename?: 'PricingStrategy', applicableOnDates?: Array<string | null> | null, unitPrice: { __typename?: 'Price', amount: number } } | null> }, extras?: Array<{ __typename?: 'BookingExtraItem', type: ExtraType, quantity: number } | null> | null } | null>, attachments: Array<{ __typename: 'Attachment', id: string, name: string, size: number, createdAt: number } | null> } | null };

export type CreateLeadMutationVariables = Exact<{
  input: CreateLeadInput;
}>;


export type CreateLeadMutation = { __typename?: 'Mutation', createLead?: { __typename?: 'Lead', id: string, createdAt: number, updatedAt?: number | null, arrivalDate?: string | null, departureDate?: string | null, notes: Array<string | null>, status: LeadStatus, source: LeadSource, customer: { __typename?: 'CustomerLead', name: string, email?: string | null, phoneNumber?: string | null }, guests?: Array<{ __typename?: 'GuestLead', fullName: string, age?: number | null, gender?: Gender | null } | null> | null, items: Array<{ __typename?: 'LeadItem', quantity: number, offering: { __typename?: 'RoomOffering', id: string, name: string } } | null> } | null };

export type CreatePackageMutationVariables = Exact<{
  input: CreatePackageInput;
}>;


export type CreatePackageMutation = { __typename?: 'Mutation', createPackage?: { __typename?: 'Package', id: string, name: string, slug: string } | null };

export type CreateTeamStaffMutationVariables = Exact<{
  input: CreateTeamStaffInput;
}>;


export type CreateTeamStaffMutation = { __typename?: 'Mutation', createTeamStaff?: { __typename?: 'StaffWithCredentials', id: string, name: string, email: string, password: string } | null };

export type DeactivateStaffMutationVariables = Exact<{
  input: DeactivateStaffInput;
}>;


export type DeactivateStaffMutation = { __typename?: 'Mutation', deactivateStaff?: boolean | null };

export type DeletePackageMutationVariables = Exact<{
  input: DeletePackageInput;
}>;


export type DeletePackageMutation = { __typename?: 'Mutation', deletePackage?: boolean | null };

export type RemoveSupplementaryItemInputMutationVariables = Exact<{
  input: RemoveSupplementaryItemInput;
}>;


export type RemoveSupplementaryItemInputMutation = { __typename?: 'Mutation', removeSupplementaryItem?: { __typename: 'Booking', id: string } | null };

export type DeleteTransferRequestMutationVariables = Exact<{
  input: DeleteTransferRequestInput;
}>;


export type DeleteTransferRequestMutation = { __typename?: 'Mutation', deleteTransferRequest?: boolean | null };

export type GrantAgentWorkspaceAccessMutationVariables = Exact<{
  input: GrantAgentWorkspaceAccessInput;
}>;


export type GrantAgentWorkspaceAccessMutation = { __typename?: 'Mutation', grantAgentWorkspaceAccess?: { __typename?: 'Agent', id: string, name: string, workspaces: Array<{ __typename?: 'Workspace', id: string, name: string } | null> } | null };

export type LoginStaffMutationVariables = Exact<{
  input: LoginStaffInput;
}>;


export type LoginStaffMutation = { __typename?: 'Mutation', loginStaff?: { __typename: 'StaffProtected', id: string, role: Role, team: { __typename?: 'Agent', id: string, type: TeamType, name: string } | { __typename?: 'OperatorTeam', id: string, type: TeamType, name: string } } | null };

export type MarkAllNotificationsAsReadMutationVariables = Exact<{
  input: MarkAllNotificationsAsReadInput;
}>;


export type MarkAllNotificationsAsReadMutation = { __typename?: 'Mutation', markAllNotificationsAsRead?: { __typename?: 'MarkAllNotificationsAsReadResult', count: number } | null };

export type MarkNotificationAsReadMutationVariables = Exact<{
  input: MarkNotificationAsReadInput;
}>;


export type MarkNotificationAsReadMutation = { __typename?: 'Mutation', markNotificationAsRead?: { __typename?: 'Notification', id: string, read: boolean, readAt?: number | null } | null };

export type RemoveItemFromLeadMutationVariables = Exact<{
  input: RemoveItemFromLeadInput;
}>;


export type RemoveItemFromLeadMutation = { __typename?: 'Mutation', removeItemFromLead?: { __typename?: 'Lead', id: string, items: Array<{ __typename?: 'LeadItem', quantity: number, offering: { __typename?: 'RoomOffering', id: string, name: string, slug: string } } | null> } | null };

export type RemovePaymentMutationVariables = Exact<{
  input: RemovePaymentInput;
}>;


export type RemovePaymentMutation = { __typename?: 'Mutation', removePayment?: { __typename: 'Booking', id: string } | null };

export type ResetStaffPasswordMutationVariables = Exact<{
  input: ResetStaffPasswordInput;
}>;


export type ResetStaffPasswordMutation = { __typename?: 'Mutation', resetStaffPassword?: { __typename?: 'StaffWithCredentials', id: string, name: string, email: string, password: string } | null };

export type SettleAgentBookingMutationVariables = Exact<{
  input: SettleAgentBookingInput;
}>;


export type SettleAgentBookingMutation = { __typename?: 'Mutation', settleAgentBooking?: { __typename?: 'Booking', id: string, reference: string, settlement?: { __typename?: 'AgentSettlement', settled: boolean, settledAt: number } | null } | null };

export type UpdateAgentMutationVariables = Exact<{
  input: UpdateAgentInput;
}>;


export type UpdateAgentMutation = { __typename?: 'Mutation', updateAgent?: { __typename: 'Agent', id: string, name: string, email: string, phoneNumber: string, contactName: string, url: string, workspaces: Array<{ __typename?: 'Workspace', id: string, name: string } | null>, commissions: Array<{ __typename?: 'AgentCommission', commissionPercentage: number, offering: { __typename?: 'RoomOffering', id: string, name: string } } | null> } | null };

export type UpdateBookingMutationVariables = Exact<{
  input: UpdateBookingInput;
}>;


export type UpdateBookingMutation = { __typename?: 'Mutation', updateBooking?: { __typename: 'Booking', id: string, status: BookingStatus, arrivalDate: string, reference: string, externalReference?: string | null, departureDate: string, notes: Array<string | null>, experiences?: Array<string | null> | null, instructions: Array<string | null>, source: BookingSource, updatedAt?: number | null, createdAt: number, agent?: { __typename: 'Agent', id: string, name: string } | null, settlement?: { __typename?: 'AgentSettlement', settled: boolean, settledAt: number } | null, createdBy?: { __typename: 'StaffPublic', id: string, name: string } | null, updatedBy?: { __typename: 'StaffPublic', id: string, name: string } | null, invoices: Array<{ __typename: 'Invoice', id: string, status: InvoiceStatus, netPrice: number, grossPrice: number, amountEarned: number, gstIncurred: number, amountOwed: number, amountRemaining: number, payments: Array<{ __typename?: 'Payment', provider: PaymentProvider, status: PaymentStatus, reference?: string | null, id: string, createdAt: number, note?: string | null, amountPaid: { __typename?: 'Price', amount: number, currency: Currency } } | null>, supplementaryItems: Array<{ __typename?: 'SupplementaryItem', name: string, quantity: number, gst: number, discount?: number | null, price: { __typename?: 'Price', amount: number, currency: Currency } } | null> } | null>, transfers: Array<{ __typename: 'TransferRequest', id: string, type: TransferType, location: string, scheduledAt: string, scheduledTime: string, status: TransferStatus, details?: string | null } | null>, reservation?: { __typename: 'Reservation', id: string, status: ReservationStatus, items: Array<{ __typename?: 'ReservationItem', reference?: string | null, references?: Array<string | null> | null, room: { __typename?: 'Room', id: string, offering: { __typename?: 'RoomOffering', slug: string, name: string } } } | null> } | null, customer: { __typename: 'Customer', id: string, name: string, email?: string | null, phoneNumber?: string | null, type: CustomerType, quality: DataQuality }, package?: { __typename: 'Package', id: string, name: string, slug: string, description: string } | null, guests: Array<{ __typename: 'Guest', id: string, fullName: string, attribution: GuestKind, age: number, gender: Gender } | null>, items: Array<{ __typename?: 'BookingItem', quantity: number, discount?: number | null, offering: { __typename: 'RoomOffering', id: string, slug: string, name: string, capacity: number, inventory: number, pricing: Array<{ __typename?: 'PricingStrategy', applicableOnDates?: Array<string | null> | null, unitPrice: { __typename?: 'Price', amount: number } } | null> }, extras?: Array<{ __typename?: 'BookingExtraItem', type: ExtraType, quantity: number } | null> | null } | null>, attachments: Array<{ __typename: 'Attachment', id: string, name: string, size: number, createdAt: number } | null> } | null };

export type UpdateCustomerMutationVariables = Exact<{
  input: UpdateCustomerInput;
}>;


export type UpdateCustomerMutation = { __typename?: 'Mutation', updateCustomer?: { __typename: 'Customer', id: string, name: string, phoneNumber?: string | null, email?: string | null } | null };

export type UpdateLeadStatusMutationVariables = Exact<{
  input: UpdateLeadStatusInput;
}>;


export type UpdateLeadStatusMutation = { __typename?: 'Mutation', updateLeadStatus?: { __typename?: 'Lead', id: string, status: LeadStatus, updatedAt?: number | null } | null };

export type UpdateLeadMutationVariables = Exact<{
  input: UpdateLeadInput;
}>;


export type UpdateLeadMutation = { __typename?: 'Mutation', updateLead?: { __typename?: 'Lead', id: string, createdAt: number, updatedAt?: number | null, arrivalDate?: string | null, departureDate?: string | null, notes: Array<string | null>, status: LeadStatus, source: LeadSource, customer: { __typename?: 'CustomerLead', name: string, email?: string | null, phoneNumber?: string | null }, items: Array<{ __typename?: 'LeadItem', quantity: number, offering: { __typename?: 'RoomOffering', id: string, name: string, slug: string } } | null>, guests?: Array<{ __typename?: 'GuestLead', fullName: string, age?: number | null, gender?: Gender | null } | null> | null } | null };

export type UpdatePackageMutationVariables = Exact<{
  input: UpdatePackageInput;
}>;


export type UpdatePackageMutation = { __typename?: 'Mutation', updatePackage?: { __typename?: 'Package', id: string, name: string, slug: string } | null };

export type UpdatePaymentMutationVariables = Exact<{
  input: UpdatePaymentInput;
}>;


export type UpdatePaymentMutation = { __typename?: 'Mutation', updatePayment?: { __typename: 'Payment', id: string } | null };

export type UpdateReservationReferencesMutationVariables = Exact<{
  input: UpdateReservationReferencesInput;
}>;


export type UpdateReservationReferencesMutation = { __typename?: 'Mutation', updateReservationReferences?: { __typename?: 'Reservation', id: string, status: ReservationStatus, items: Array<{ __typename?: 'ReservationItem', references?: Array<string | null> | null } | null> } | null };

export type UpdateReservationStatusMutationVariables = Exact<{
  input: UpdateReservationStatusInput;
}>;


export type UpdateReservationStatusMutation = { __typename?: 'Mutation', updateReservationStatus?: { __typename?: 'Reservation', id: string, status: ReservationStatus } | null };

export type UpdateRoomOfferingExtrasMutationVariables = Exact<{
  input: UpdateRoomOfferingExtrasInput;
}>;


export type UpdateRoomOfferingExtrasMutation = { __typename?: 'Mutation', updateRoomOfferingExtras?: { __typename?: 'RoomOffering', id: string, name: string, extras?: Array<{ __typename?: 'OfferingExtra', type: ExtraType, name: string, maxQuantityPerRoom?: number | null, gst: number, price: { __typename?: 'Price', amount: number, currency: Currency } } | null> | null } | null };

export type UpdateRoomOfferingInventoryMutationVariables = Exact<{
  input: UpdateRoomOfferingInventoryInput;
}>;


export type UpdateRoomOfferingInventoryMutation = { __typename?: 'Mutation', updateRoomOfferingInventory?: { __typename?: 'RoomOffering', id: string, name: string, inventory: number, capacity: number } | null };

export type UpdateStaffRoleMutationVariables = Exact<{
  input: UpdateStaffRoleInput;
}>;


export type UpdateStaffRoleMutation = { __typename?: 'Mutation', updateStaffRole?: { __typename?: 'StaffProtected', id: string, name: string, email: string, role: Role, createdAt: number, updatedAt?: number | null } | null };

export type UpdateSupplementaryItemMutationVariables = Exact<{
  input: UpdateSupplementaryItemInput;
}>;


export type UpdateSupplementaryItemMutation = { __typename?: 'Mutation', updateSupplementaryItem?: { __typename: 'Booking', id: string } | null };

export type UpdateTransferRequestMutationVariables = Exact<{
  input: UpdateTransferRequestInput;
}>;


export type UpdateTransferRequestMutation = { __typename?: 'Mutation', updateTransferRequest?: { __typename: 'TransferRequest', id: string } | null };

export type CanSettleBookingQueryVariables = Exact<{
  input: CanSettleBookingInput;
}>;


export type CanSettleBookingQuery = { __typename?: 'Query', canSettleBooking?: { __typename?: 'CanSettleBookingResult', canSettle: boolean, required: number, available: number, reason?: string | null } | null };

export type CancelBookingMutationVariables = Exact<{
  input: CancelBookingInput;
}>;


export type CancelBookingMutation = { __typename?: 'Mutation', cancelBooking?: { __typename: 'Booking', id: string, status: BookingStatus } | null };

export type GetActivityForEntityQueryVariables = Exact<{
  input: ActivityForEntityInput;
}>;


export type GetActivityForEntityQuery = { __typename?: 'Query', activityForEntity?: Array<{ __typename?: 'ActivityEntry', id: string, type: ActivityType, summary: string, createdAt: number, actor: { __typename?: 'StaffPublic', id: string, name: string }, changes?: Array<{ __typename?: 'ActivityFieldChange', property: string, label: string, before?: string | null, after?: string | null } | null> | null } | null> | null };

export type GetAgentByIdQueryVariables = Exact<{
  input: GetAgentByIdInput;
}>;


export type GetAgentByIdQuery = { __typename?: 'Query', getAgentById?: { __typename: 'Agent', id: string, name: string, email: string, phoneNumber: string, contactName: string, url: string, createdAt: number, workspaces: Array<{ __typename?: 'Workspace', id: string, name: string, displayName: string, namespace: string } | null>, commissions: Array<{ __typename?: 'AgentCommission', commissionPercentage: number, offering: { __typename?: 'RoomOffering', id: string, name: string } } | null>, bookingsConnection?: { __typename?: 'AgentBookingsConnection', edges?: Array<{ __typename?: 'AgentBookingsEdge', node?: { __typename?: 'Booking', id: string, reference: string, status: BookingStatus, arrivalDate: string, departureDate: string, customer: { __typename?: 'Customer', id: string, name: string }, invoices: Array<{ __typename?: 'Invoice', id: string, status: InvoiceStatus, netPrice: number, grossPrice: number, amountEarned: number, amountOwed: number } | null>, settlement?: { __typename?: 'AgentSettlement', settled: boolean, settledAt: number } | null } | null } | null> | null } | null } | null };

export type GetAgentLedgerSummaryQueryVariables = Exact<{
  input: GetAgentLedgerSummaryInput;
}>;


export type GetAgentLedgerSummaryQuery = { __typename?: 'Query', getAgentLedgerSummary?: { __typename?: 'AgentLedgerSummary', totalOwedToNivaas: number, totalPaidToNivaas: number, pendingPayments: number, availableCredit: number, outstandingBalance: number } | null };

export type GetBookingByIdQueryVariables = Exact<{
  input: GetBookingInput;
}>;


export type GetBookingByIdQuery = { __typename?: 'Query', getBooking?: { __typename: 'Booking', id: string, status: BookingStatus, arrivalDate: string, reference: string, externalReference?: string | null, departureDate: string, notes: Array<string | null>, experiences?: Array<string | null> | null, instructions: Array<string | null>, source: BookingSource, updatedAt?: number | null, createdAt: number, agent?: { __typename: 'Agent', id: string, name: string } | null, settlement?: { __typename?: 'AgentSettlement', settled: boolean, settledAt: number } | null, createdBy?: { __typename: 'StaffPublic', id: string, name: string } | null, updatedBy?: { __typename: 'StaffPublic', id: string, name: string } | null, invoices: Array<{ __typename: 'Invoice', id: string, status: InvoiceStatus, netPrice: number, grossPrice: number, amountEarned: number, gstIncurred: number, amountOwed: number, amountRemaining: number, payments: Array<{ __typename?: 'Payment', provider: PaymentProvider, status: PaymentStatus, reference?: string | null, id: string, createdAt: number, note?: string | null, amountPaid: { __typename?: 'Price', amount: number, currency: Currency } } | null>, supplementaryItems: Array<{ __typename?: 'SupplementaryItem', name: string, quantity: number, gst: number, discount?: number | null, price: { __typename?: 'Price', amount: number, currency: Currency } } | null> } | null>, transfers: Array<{ __typename: 'TransferRequest', id: string, type: TransferType, location: string, scheduledAt: string, scheduledTime: string, status: TransferStatus, details?: string | null } | null>, reservation?: { __typename: 'Reservation', id: string, status: ReservationStatus, items: Array<{ __typename?: 'ReservationItem', reference?: string | null, references?: Array<string | null> | null, room: { __typename?: 'Room', id: string, offering: { __typename?: 'RoomOffering', slug: string, name: string } } } | null> } | null, customer: { __typename: 'Customer', id: string, name: string, email?: string | null, phoneNumber?: string | null, type: CustomerType, quality: DataQuality }, package?: { __typename: 'Package', id: string, name: string, slug: string, description: string } | null, guests: Array<{ __typename: 'Guest', id: string, fullName: string, attribution: GuestKind, age: number, gender: Gender } | null>, items: Array<{ __typename?: 'BookingItem', quantity: number, discount?: number | null, offering: { __typename: 'RoomOffering', id: string, slug: string, name: string, capacity: number, inventory: number, pricing: Array<{ __typename?: 'PricingStrategy', applicableOnDates?: Array<string | null> | null, unitPrice: { __typename?: 'Price', amount: number } } | null> }, extras?: Array<{ __typename?: 'BookingExtraItem', type: ExtraType, quantity: number } | null> | null } | null>, attachments: Array<{ __typename: 'Attachment', id: string, name: string, size: number, createdAt: number } | null> } | null };

export type ListInventoryItemsQueryVariables = Exact<{
  input: ListInventoryItemsInput;
}>;


export type ListInventoryItemsQuery = { __typename?: 'Query', listInventoryItems?: Array<{ __typename: 'InventoryEntry', id: string, available: number } | null> | null };

export type GetLeadQueryVariables = Exact<{
  input: GetLeadInput;
}>;


export type GetLeadQuery = { __typename?: 'Query', getLead?: { __typename?: 'Lead', id: string, createdAt: number, updatedAt?: number | null, arrivalDate?: string | null, departureDate?: string | null, notes: Array<string | null>, status: LeadStatus, source: LeadSource, customer: { __typename?: 'CustomerLead', name: string, email?: string | null, phoneNumber?: string | null }, items: Array<{ __typename?: 'LeadItem', quantity: number, offering: { __typename?: 'RoomOffering', id: string, name: string } } | null>, guests?: Array<{ __typename?: 'GuestLead', fullName: string, age?: number | null, gender?: Gender | null } | null> | null } | null };

export type GetStaffByIdQueryVariables = Exact<{
  input: GetStaffByIdInput;
}>;


export type GetStaffByIdQuery = { __typename?: 'Query', getStaffById?: { __typename: 'StaffPublic', id: string, name: string } | null };

export type GetTeamByIdQueryVariables = Exact<{
  input: GetTeamByIdInput;
}>;


export type GetTeamByIdQuery = { __typename?: 'Query', getTeamById?: { __typename?: 'Agent', id: string, name: string, type: TeamType, email: string, phoneNumber: string, contactName: string, url: string, createdAt: number, workspaces: Array<{ __typename?: 'Workspace', id: string, name: string, namespace: string } | null> } | { __typename?: 'OperatorTeam', id: string, name: string, type: TeamType, email: string, phoneNumber: string, contactName: string, url: string, createdAt: number, workspaces: Array<{ __typename?: 'Workspace', id: string, name: string, namespace: string } | null> } | null };

export type ListAgentPaymentsQueryVariables = Exact<{
  input: ListAgentPaymentsInput;
}>;


export type ListAgentPaymentsQuery = { __typename?: 'Query', listAgentPayments?: Array<{ __typename?: 'AgentPayment', id: string, reference: string, note?: string | null, status: AgentPaymentStatus, confirmedAt?: number | null, createdAt: number, updatedAt?: number | null, amount: { __typename?: 'Price', amount: number, currency: Currency }, createdBy?: { __typename?: 'StaffPublic', id: string, name: string } | null, confirmedBy?: { __typename?: 'StaffPublic', id: string, name: string } | null } | null> | null };

export type ListAgentsQueryVariables = Exact<{
  input: ListAgentsInput;
}>;


export type ListAgentsQuery = { __typename?: 'Query', listAgents?: Array<{ __typename: 'Agent', id: string, name: string, email: string, phoneNumber: string, contactName: string, url: string, createdAt: number, workspaces: Array<{ __typename?: 'Workspace', id: string, name: string } | null>, commissions: Array<{ __typename?: 'AgentCommission', commissionPercentage: number, offering: { __typename?: 'RoomOffering', id: string, name: string } } | null> } | null> | null };

export type ListAvailableRoomOfferingsQueryVariables = Exact<{
  input: ListAvailableRoomOfferingsInput;
}>;


export type ListAvailableRoomOfferingsQuery = { __typename?: 'Query', listAvailableRoomOfferings?: Array<{ __typename: 'RoomOffering', id: string, name: string, slug: string, capacity: number, inventory: number, description: string, availableFromDate: string, availableUntilDate: string, pricing: Array<{ __typename?: 'PricingStrategy', gst: number, applicableFromDate: string, applicableUntilDate?: string | null, applicableOnDates?: Array<string | null> | null, unitPrice: { __typename?: 'Price', amount: number, currency: Currency } } | null> } | null> | null };

export type ListBookingsQueryVariables = Exact<{
  input: ListBookingsInput;
}>;


export type ListBookingsQuery = { __typename?: 'Query', listBookings?: Array<{ __typename: 'Booking', id: string, status: BookingStatus, arrivalDate: string, reference: string, externalReference?: string | null, departureDate: string, notes: Array<string | null>, experiences?: Array<string | null> | null, instructions: Array<string | null>, source: BookingSource, updatedAt?: number | null, createdAt: number, agent?: { __typename: 'Agent', id: string, name: string } | null, settlement?: { __typename?: 'AgentSettlement', settled: boolean, settledAt: number } | null, createdBy?: { __typename: 'StaffPublic', id: string, name: string } | null, updatedBy?: { __typename: 'StaffPublic', id: string, name: string } | null, invoices: Array<{ __typename: 'Invoice', id: string, status: InvoiceStatus, netPrice: number, grossPrice: number, amountEarned: number, gstIncurred: number, amountOwed: number, amountRemaining: number, payments: Array<{ __typename?: 'Payment', provider: PaymentProvider, status: PaymentStatus, reference?: string | null, id: string, createdAt: number, note?: string | null, amountPaid: { __typename?: 'Price', amount: number, currency: Currency } } | null>, supplementaryItems: Array<{ __typename?: 'SupplementaryItem', name: string, quantity: number, gst: number, discount?: number | null, price: { __typename?: 'Price', amount: number, currency: Currency } } | null> } | null>, transfers: Array<{ __typename: 'TransferRequest', id: string, type: TransferType, location: string, scheduledAt: string, scheduledTime: string, status: TransferStatus, details?: string | null } | null>, reservation?: { __typename: 'Reservation', id: string, status: ReservationStatus, items: Array<{ __typename?: 'ReservationItem', reference?: string | null, references?: Array<string | null> | null, room: { __typename?: 'Room', id: string, offering: { __typename?: 'RoomOffering', slug: string, name: string } } } | null> } | null, customer: { __typename: 'Customer', id: string, name: string, email?: string | null, phoneNumber?: string | null, type: CustomerType, quality: DataQuality }, package?: { __typename: 'Package', id: string, name: string, slug: string, description: string } | null, guests: Array<{ __typename: 'Guest', id: string, fullName: string, attribution: GuestKind, age: number, gender: Gender } | null>, items: Array<{ __typename?: 'BookingItem', quantity: number, discount?: number | null, offering: { __typename: 'RoomOffering', id: string, slug: string, name: string, capacity: number, inventory: number, pricing: Array<{ __typename?: 'PricingStrategy', applicableOnDates?: Array<string | null> | null, unitPrice: { __typename?: 'Price', amount: number } } | null> }, extras?: Array<{ __typename?: 'BookingExtraItem', type: ExtraType, quantity: number } | null> | null } | null>, attachments: Array<{ __typename: 'Attachment', id: string, name: string, size: number, createdAt: number } | null> } | null> | null };

export type ListCustomersQueryVariables = Exact<{
  input: ListCustomersInput;
}>;


export type ListCustomersQuery = { __typename?: 'Query', listCustomers?: Array<{ __typename: 'Customer', id: string, name: string, phoneNumber?: string | null, email?: string | null, type: CustomerType, bookingsConnection?: { __typename?: 'CustomerBookingsConnection', edges?: Array<{ __typename?: 'CustomerBookingsEdge', node?: { __typename: 'Booking', id: string, status: BookingStatus, arrivalDate: string, departureDate: string } | null } | null> | null } | null } | null> | null };

export type ListInventoryItemsVerboseQueryVariables = Exact<{
  input: ListInventoryItemsVerboseInput;
}>;


export type ListInventoryItemsVerboseQuery = { __typename?: 'Query', listInventoryItemsVerbose?: Array<{ __typename?: 'InventoryEntryVerbose', id: string, taken: number, inventory: number, pax: number, availableRoomIds: Array<string | null> } | null> | null };

export type ListLeadsQueryVariables = Exact<{
  input: ListLeadsInput;
}>;


export type ListLeadsQuery = { __typename?: 'Query', listLeads?: Array<{ __typename?: 'Lead', id: string, createdAt: number, updatedAt?: number | null, arrivalDate?: string | null, departureDate?: string | null, notes: Array<string | null>, status: LeadStatus, source: LeadSource, customer: { __typename?: 'CustomerLead', name: string, email?: string | null, phoneNumber?: string | null }, items: Array<{ __typename?: 'LeadItem', quantity: number, offering: { __typename?: 'RoomOffering', id: string, name: string } } | null>, supplementaryItems?: Array<{ __typename?: 'SupplementaryItem', name: string, quantity: number, gst: number, price: { __typename?: 'Price', amount: number, currency: Currency } } | null> | null, guests?: Array<{ __typename?: 'GuestLead', fullName: string, age?: number | null, gender?: Gender | null } | null> | null } | null> | null };

export type ListPackagesQueryVariables = Exact<{
  input: ListPackagesInput;
}>;


export type ListPackagesQuery = { __typename?: 'Query', listPackages?: Array<{ __typename: 'Package', id: string, name: string, slug: string, description: string, availableFromDate: string, availableUntilDate: string, isActive: boolean, createdAt: number, allowedOfferings: Array<{ __typename?: 'RoomOffering', id: string, name: string, slug: string } | null>, supplementaryItems?: Array<{ __typename?: 'SupplementaryItem', name: string, quantity: number, gst: number, price: { __typename?: 'Price', amount: number, currency: Currency } } | null> | null } | null> | null };

export type ListReservationsQueryVariables = Exact<{
  input: ListReservationsInput;
}>;


export type ListReservationsQuery = { __typename?: 'Query', listReservations?: Array<{ __typename: 'Reservation', id: string, status: ReservationStatus, arrivalDate: string, departureDate: string, createdAt: number, updatedAt?: number | null, createdBy?: { __typename: 'StaffPublic', id: string, name: string } | null, updatedBy?: { __typename: 'StaffPublic', id: string, name: string } | null, items: Array<{ __typename?: 'ReservationItem', reference?: string | null, references?: Array<string | null> | null, room: { __typename: 'Room', id: string, offering: { __typename?: 'RoomOffering', name: string, inventory: number } } } | null>, customer: { __typename: 'Customer', id: string, name: string, phoneNumber?: string | null, email?: string | null, type: CustomerType }, booking: { __typename: 'Booking', id: string, reference: string, createdAt: number, source: BookingSource, status: BookingStatus, instructions: Array<string | null>, notes: Array<string | null>, guests: Array<{ __typename: 'Guest', id: string, attribution: GuestKind, age: number, fullName: string } | null>, transfers: Array<{ __typename: 'TransferRequest', id: string, type: TransferType, details?: string | null, location: string, scheduledAt: string, scheduledTime: string } | null>, customer: { __typename: 'Customer', id: string, name: string } } } | null> | null };

export type ListRoomOfferingsQueryVariables = Exact<{
  input: ListRoomOfferingsInput;
}>;


export type ListRoomOfferingsQuery = { __typename?: 'Query', listRoomOfferings?: Array<{ __typename: 'RoomOffering', id: string, name: string, slug: string, capacity: number, inventory: number, description: string, availableFromDate: string, availableUntilDate: string, pricing: Array<{ __typename?: 'PricingStrategy', gst: number, applicableFromDate: string, applicableUntilDate?: string | null, applicableOnDates?: Array<string | null> | null, unitPrice: { __typename?: 'Price', amount: number, currency: Currency } } | null>, extras?: Array<{ __typename?: 'OfferingExtra', type: ExtraType, name: string, maxQuantityPerRoom?: number | null, gst: number, price: { __typename?: 'Price', amount: number, currency: Currency } } | null> | null } | null> | null };

export type ListRoomsQueryVariables = Exact<{
  input: ListAllRoomsInput;
}>;


export type ListRoomsQuery = { __typename?: 'Query', listAllRooms?: Array<{ __typename: 'Room', id: string, slots: Array<string | null>, status?: RoomStatus | null, offering: { __typename: 'RoomOffering', id: string, slug: string, name: string, capacity: number, inventory: number } } | null> | null };

export type ListTeamStaffQueryVariables = Exact<{
  input: ListTeamStaffInput;
}>;


export type ListTeamStaffQuery = { __typename?: 'Query', listTeamStaff?: Array<{ __typename?: 'StaffProtected', id: string, name: string, email: string, role: Role, status?: StaffStatus | null, createdAt: number } | null> | null };

export type ListWorkspacesQueryVariables = Exact<{
  input: ListWorkspacesInput;
}>;


export type ListWorkspacesQuery = { __typename?: 'Query', listWorkspaces?: Array<{ __typename: 'Workspace', id: string, displayName: string, name: string, namespace: string, roomOfferingsConnection?: { __typename?: 'WorkspaceRoomOfferingsConnection', edges?: Array<{ __typename?: 'WorkspaceRoomOfferingsEdge', node?: { __typename?: 'RoomOffering', id: string, name: string, slug: string } | null } | null> | null } | null } | null> | null };

export type MyNotificationsQueryVariables = Exact<{
  input: MyNotificationsInput;
}>;


export type MyNotificationsQuery = { __typename?: 'Query', myNotifications?: { __typename?: 'MyNotificationsResult', unreadCount: number, notifications: Array<{ __typename?: 'Notification', id: string, title: string, body: string, read: boolean, readAt?: number | null, createdAt: number, entityId?: string | null, notificationType: string } | null> } | null };

export type UnreadNotificationCountQueryVariables = Exact<{
  input: UnreadNotificationCountInput;
}>;


export type UnreadNotificationCountQuery = { __typename?: 'Query', unreadNotificationCount?: number | null };

export const BookingFragmentFragmentDoc = gql`
    fragment BookingFragment on Booking {
  id
  __typename
  status
  arrivalDate
  reference
  externalReference
  departureDate
  agent {
    id
    __typename
    name
  }
  settlement {
    settled
    settledAt
  }
  createdBy {
    id
    __typename
    name
  }
  updatedBy {
    id
    __typename
    name
  }
  invoices {
    id
    __typename
    status
    netPrice
    grossPrice
    amountEarned
    gstIncurred
    amountOwed
    status
    amountRemaining
    payments {
      provider
      status
      amountPaid {
        amount
        currency
      }
      reference
      id
      createdAt
      note
    }
    supplementaryItems {
      name
      price {
        amount
        currency
      }
      quantity
      gst
      discount
    }
  }
  transfers {
    id
    __typename
    type
    location
    id
    scheduledAt
    scheduledTime
    status
    details
  }
  notes
  experiences
  instructions
  reservation {
    id
    __typename
    status
    items {
      room {
        id
        offering {
          slug
          name
        }
      }
      reference
      references
    }
  }
  customer {
    id
    __typename
    name
    email
    phoneNumber
    type
    quality
  }
  package {
    id
    __typename
    name
    slug
    description
  }
  source
  updatedAt
  createdAt
  guests {
    id
    __typename
    fullName
    attribution
    age
    gender
  }
  items {
    offering {
      id
      __typename
      slug
      name
      capacity
      inventory
      pricing {
        unitPrice {
          amount
        }
        applicableOnDates
      }
    }
    quantity
    discount
    extras {
      type
      quantity
    }
  }
  attachments {
    id
    __typename
    name
    size
    createdAt
  }
}
    `;
export const AddItemToLeadDocument = gql`
    mutation AddItemToLead($input: AddItemToLeadInput!) {
  addItemToLead(input: $input) {
    id
    items {
      offering {
        id
        name
        slug
      }
      quantity
    }
  }
}
    `;

export function useAddItemToLeadMutation() {
  return Urql.useMutation<AddItemToLeadMutation, AddItemToLeadMutationVariables>(AddItemToLeadDocument);
};
export const AddPaymentDocument = gql`
    mutation AddPayment($input: AddPaymentInput!) {
  addPayment(input: $input) {
    id
    __typename
  }
}
    `;

export function useAddPaymentMutation() {
  return Urql.useMutation<AddPaymentMutation, AddPaymentMutationVariables>(AddPaymentDocument);
};
export const AddSupplementaryItemDocument = gql`
    mutation AddSupplementaryItem($input: AddSupplementaryItemInput!) {
  addSupplementaryItem(input: $input) {
    id
    __typename
  }
}
    `;

export function useAddSupplementaryItemMutation() {
  return Urql.useMutation<AddSupplementaryItemMutation, AddSupplementaryItemMutationVariables>(AddSupplementaryItemDocument);
};
export const AddTransferRequestDocument = gql`
    mutation addTransferRequest($input: AddTransferRequestInput!) {
  addTransferRequest(input: $input) {
    id
    __typename
  }
}
    `;

export function useAddTransferRequestMutation() {
  return Urql.useMutation<AddTransferRequestMutation, AddTransferRequestMutationVariables>(AddTransferRequestDocument);
};
export const CalculateBookingPriceDocument = gql`
    mutation CalculateBookingPrice($input: CalculateBookingPriceInput!) {
  calculateBookingPrice(input: $input) {
    netPrice
    grossPrice
  }
}
    `;

export function useCalculateBookingPriceMutation() {
  return Urql.useMutation<CalculateBookingPriceMutation, CalculateBookingPriceMutationVariables>(CalculateBookingPriceDocument);
};
export const CancelLeadDocument = gql`
    mutation CancelLead($input: CancelLeadInput!) {
  cancelLead(input: $input) {
    id
    status
    updatedAt
  }
}
    `;

export function useCancelLeadMutation() {
  return Urql.useMutation<CancelLeadMutation, CancelLeadMutationVariables>(CancelLeadDocument);
};
export const ConfirmAgentPaymentDocument = gql`
    mutation ConfirmAgentPayment($input: ConfirmAgentPaymentInput!) {
  confirmAgentPayment(input: $input) {
    id
    status
    confirmedAt
  }
}
    `;

export function useConfirmAgentPaymentMutation() {
  return Urql.useMutation<ConfirmAgentPaymentMutation, ConfirmAgentPaymentMutationVariables>(ConfirmAgentPaymentDocument);
};
export const CreateAgentPaymentDocument = gql`
    mutation CreateAgentPayment($input: CreateAgentPaymentInput!) {
  createAgentPayment(input: $input) {
    id
    amount {
      amount
      currency
    }
    reference
    note
    status
    createdAt
  }
}
    `;

export function useCreateAgentPaymentMutation() {
  return Urql.useMutation<CreateAgentPaymentMutation, CreateAgentPaymentMutationVariables>(CreateAgentPaymentDocument);
};
export const CreateAgentDocument = gql`
    mutation CreateAgent($input: CreateAgentInput!) {
  createAgent(input: $input) {
    id
    __typename
    name
    email
    phoneNumber
    contactName
    url
    workspaces {
      id
      name
    }
    commissions {
      commissionPercentage
      offering {
        id
        name
      }
    }
  }
}
    `;

export function useCreateAgentMutation() {
  return Urql.useMutation<CreateAgentMutation, CreateAgentMutationVariables>(CreateAgentDocument);
};
export const CreateBookingDocument = gql`
    mutation CreateBooking($input: CreateBookingInput!) {
  createBooking(input: $input) {
    ...BookingFragment
  }
}
    ${BookingFragmentFragmentDoc}`;

export function useCreateBookingMutation() {
  return Urql.useMutation<CreateBookingMutation, CreateBookingMutationVariables>(CreateBookingDocument);
};
export const CreateLeadDocument = gql`
    mutation CreateLead($input: CreateLeadInput!) {
  createLead(input: $input) {
    id
    createdAt
    updatedAt
    customer {
      name
      email
      phoneNumber
    }
    arrivalDate
    departureDate
    guests {
      fullName
      age
      gender
    }
    notes
    status
    source
    items {
      offering {
        id
        name
      }
      quantity
    }
  }
}
    `;

export function useCreateLeadMutation() {
  return Urql.useMutation<CreateLeadMutation, CreateLeadMutationVariables>(CreateLeadDocument);
};
export const CreatePackageDocument = gql`
    mutation CreatePackage($input: CreatePackageInput!) {
  createPackage(input: $input) {
    id
    name
    slug
  }
}
    `;

export function useCreatePackageMutation() {
  return Urql.useMutation<CreatePackageMutation, CreatePackageMutationVariables>(CreatePackageDocument);
};
export const CreateTeamStaffDocument = gql`
    mutation CreateTeamStaff($input: CreateTeamStaffInput!) {
  createTeamStaff(input: $input) {
    id
    name
    email
    password
  }
}
    `;

export function useCreateTeamStaffMutation() {
  return Urql.useMutation<CreateTeamStaffMutation, CreateTeamStaffMutationVariables>(CreateTeamStaffDocument);
};
export const DeactivateStaffDocument = gql`
    mutation DeactivateStaff($input: DeactivateStaffInput!) {
  deactivateStaff(input: $input)
}
    `;

export function useDeactivateStaffMutation() {
  return Urql.useMutation<DeactivateStaffMutation, DeactivateStaffMutationVariables>(DeactivateStaffDocument);
};
export const DeletePackageDocument = gql`
    mutation DeletePackage($input: DeletePackageInput!) {
  deletePackage(input: $input)
}
    `;

export function useDeletePackageMutation() {
  return Urql.useMutation<DeletePackageMutation, DeletePackageMutationVariables>(DeletePackageDocument);
};
export const RemoveSupplementaryItemInputDocument = gql`
    mutation RemoveSupplementaryItemInput($input: RemoveSupplementaryItemInput!) {
  removeSupplementaryItem(input: $input) {
    id
    __typename
  }
}
    `;

export function useRemoveSupplementaryItemInputMutation() {
  return Urql.useMutation<RemoveSupplementaryItemInputMutation, RemoveSupplementaryItemInputMutationVariables>(RemoveSupplementaryItemInputDocument);
};
export const DeleteTransferRequestDocument = gql`
    mutation DeleteTransferRequest($input: DeleteTransferRequestInput!) {
  deleteTransferRequest(input: $input)
}
    `;

export function useDeleteTransferRequestMutation() {
  return Urql.useMutation<DeleteTransferRequestMutation, DeleteTransferRequestMutationVariables>(DeleteTransferRequestDocument);
};
export const GrantAgentWorkspaceAccessDocument = gql`
    mutation GrantAgentWorkspaceAccess($input: GrantAgentWorkspaceAccessInput!) {
  grantAgentWorkspaceAccess(input: $input) {
    id
    name
    workspaces {
      id
      name
    }
  }
}
    `;

export function useGrantAgentWorkspaceAccessMutation() {
  return Urql.useMutation<GrantAgentWorkspaceAccessMutation, GrantAgentWorkspaceAccessMutationVariables>(GrantAgentWorkspaceAccessDocument);
};
export const LoginStaffDocument = gql`
    mutation LoginStaff($input: LoginStaffInput!) {
  loginStaff(input: $input) {
    id
    __typename
    role
    team {
      id
      type
      name
    }
  }
}
    `;

export function useLoginStaffMutation() {
  return Urql.useMutation<LoginStaffMutation, LoginStaffMutationVariables>(LoginStaffDocument);
};
export const MarkAllNotificationsAsReadDocument = gql`
    mutation MarkAllNotificationsAsRead($input: MarkAllNotificationsAsReadInput!) {
  markAllNotificationsAsRead(input: $input) {
    count
  }
}
    `;

export function useMarkAllNotificationsAsReadMutation() {
  return Urql.useMutation<MarkAllNotificationsAsReadMutation, MarkAllNotificationsAsReadMutationVariables>(MarkAllNotificationsAsReadDocument);
};
export const MarkNotificationAsReadDocument = gql`
    mutation MarkNotificationAsRead($input: MarkNotificationAsReadInput!) {
  markNotificationAsRead(input: $input) {
    id
    read
    readAt
  }
}
    `;

export function useMarkNotificationAsReadMutation() {
  return Urql.useMutation<MarkNotificationAsReadMutation, MarkNotificationAsReadMutationVariables>(MarkNotificationAsReadDocument);
};
export const RemoveItemFromLeadDocument = gql`
    mutation RemoveItemFromLead($input: RemoveItemFromLeadInput!) {
  removeItemFromLead(input: $input) {
    id
    items {
      offering {
        id
        name
        slug
      }
      quantity
    }
  }
}
    `;

export function useRemoveItemFromLeadMutation() {
  return Urql.useMutation<RemoveItemFromLeadMutation, RemoveItemFromLeadMutationVariables>(RemoveItemFromLeadDocument);
};
export const RemovePaymentDocument = gql`
    mutation RemovePayment($input: RemovePaymentInput!) {
  removePayment(input: $input) {
    id
    __typename
  }
}
    `;

export function useRemovePaymentMutation() {
  return Urql.useMutation<RemovePaymentMutation, RemovePaymentMutationVariables>(RemovePaymentDocument);
};
export const ResetStaffPasswordDocument = gql`
    mutation ResetStaffPassword($input: ResetStaffPasswordInput!) {
  resetStaffPassword(input: $input) {
    id
    name
    email
    password
  }
}
    `;

export function useResetStaffPasswordMutation() {
  return Urql.useMutation<ResetStaffPasswordMutation, ResetStaffPasswordMutationVariables>(ResetStaffPasswordDocument);
};
export const SettleAgentBookingDocument = gql`
    mutation SettleAgentBooking($input: SettleAgentBookingInput!) {
  settleAgentBooking(input: $input) {
    id
    reference
    settlement {
      settled
      settledAt
    }
  }
}
    `;

export function useSettleAgentBookingMutation() {
  return Urql.useMutation<SettleAgentBookingMutation, SettleAgentBookingMutationVariables>(SettleAgentBookingDocument);
};
export const UpdateAgentDocument = gql`
    mutation UpdateAgent($input: UpdateAgentInput!) {
  updateAgent(input: $input) {
    id
    __typename
    name
    email
    phoneNumber
    contactName
    url
    workspaces {
      id
      name
    }
    commissions {
      commissionPercentage
      offering {
        id
        name
      }
    }
  }
}
    `;

export function useUpdateAgentMutation() {
  return Urql.useMutation<UpdateAgentMutation, UpdateAgentMutationVariables>(UpdateAgentDocument);
};
export const UpdateBookingDocument = gql`
    mutation UpdateBooking($input: UpdateBookingInput!) {
  updateBooking(input: $input) {
    ...BookingFragment
  }
}
    ${BookingFragmentFragmentDoc}`;

export function useUpdateBookingMutation() {
  return Urql.useMutation<UpdateBookingMutation, UpdateBookingMutationVariables>(UpdateBookingDocument);
};
export const UpdateCustomerDocument = gql`
    mutation UpdateCustomer($input: UpdateCustomerInput!) {
  updateCustomer(input: $input) {
    id
    __typename
    name
    phoneNumber
    email
  }
}
    `;

export function useUpdateCustomerMutation() {
  return Urql.useMutation<UpdateCustomerMutation, UpdateCustomerMutationVariables>(UpdateCustomerDocument);
};
export const UpdateLeadStatusDocument = gql`
    mutation UpdateLeadStatus($input: UpdateLeadStatusInput!) {
  updateLeadStatus(input: $input) {
    id
    status
    updatedAt
  }
}
    `;

export function useUpdateLeadStatusMutation() {
  return Urql.useMutation<UpdateLeadStatusMutation, UpdateLeadStatusMutationVariables>(UpdateLeadStatusDocument);
};
export const UpdateLeadDocument = gql`
    mutation UpdateLead($input: UpdateLeadInput!) {
  updateLead(input: $input) {
    id
    createdAt
    updatedAt
    customer {
      name
      email
      phoneNumber
    }
    items {
      offering {
        id
        name
        slug
      }
      quantity
    }
    arrivalDate
    departureDate
    guests {
      fullName
      age
      gender
    }
    notes
    status
    source
  }
}
    `;

export function useUpdateLeadMutation() {
  return Urql.useMutation<UpdateLeadMutation, UpdateLeadMutationVariables>(UpdateLeadDocument);
};
export const UpdatePackageDocument = gql`
    mutation UpdatePackage($input: UpdatePackageInput!) {
  updatePackage(input: $input) {
    id
    name
    slug
  }
}
    `;

export function useUpdatePackageMutation() {
  return Urql.useMutation<UpdatePackageMutation, UpdatePackageMutationVariables>(UpdatePackageDocument);
};
export const UpdatePaymentDocument = gql`
    mutation UpdatePayment($input: UpdatePaymentInput!) {
  updatePayment(input: $input) {
    id
    __typename
  }
}
    `;

export function useUpdatePaymentMutation() {
  return Urql.useMutation<UpdatePaymentMutation, UpdatePaymentMutationVariables>(UpdatePaymentDocument);
};
export const UpdateReservationReferencesDocument = gql`
    mutation UpdateReservationReferences($input: UpdateReservationReferencesInput!) {
  updateReservationReferences(input: $input) {
    id
    status
    items {
      references
    }
  }
}
    `;

export function useUpdateReservationReferencesMutation() {
  return Urql.useMutation<UpdateReservationReferencesMutation, UpdateReservationReferencesMutationVariables>(UpdateReservationReferencesDocument);
};
export const UpdateReservationStatusDocument = gql`
    mutation UpdateReservationStatus($input: UpdateReservationStatusInput!) {
  updateReservationStatus(input: $input) {
    id
    status
  }
}
    `;

export function useUpdateReservationStatusMutation() {
  return Urql.useMutation<UpdateReservationStatusMutation, UpdateReservationStatusMutationVariables>(UpdateReservationStatusDocument);
};
export const UpdateRoomOfferingExtrasDocument = gql`
    mutation UpdateRoomOfferingExtras($input: UpdateRoomOfferingExtrasInput!) {
  updateRoomOfferingExtras(input: $input) {
    id
    name
    extras {
      type
      name
      maxQuantityPerRoom
      price {
        amount
        currency
      }
      gst
    }
  }
}
    `;

export function useUpdateRoomOfferingExtrasMutation() {
  return Urql.useMutation<UpdateRoomOfferingExtrasMutation, UpdateRoomOfferingExtrasMutationVariables>(UpdateRoomOfferingExtrasDocument);
};
export const UpdateRoomOfferingInventoryDocument = gql`
    mutation UpdateRoomOfferingInventory($input: UpdateRoomOfferingInventoryInput!) {
  updateRoomOfferingInventory(input: $input) {
    id
    name
    inventory
    capacity
  }
}
    `;

export function useUpdateRoomOfferingInventoryMutation() {
  return Urql.useMutation<UpdateRoomOfferingInventoryMutation, UpdateRoomOfferingInventoryMutationVariables>(UpdateRoomOfferingInventoryDocument);
};
export const UpdateStaffRoleDocument = gql`
    mutation UpdateStaffRole($input: UpdateStaffRoleInput!) {
  updateStaffRole(input: $input) {
    id
    name
    email
    role
    createdAt
    updatedAt
  }
}
    `;

export function useUpdateStaffRoleMutation() {
  return Urql.useMutation<UpdateStaffRoleMutation, UpdateStaffRoleMutationVariables>(UpdateStaffRoleDocument);
};
export const UpdateSupplementaryItemDocument = gql`
    mutation UpdateSupplementaryItem($input: UpdateSupplementaryItemInput!) {
  updateSupplementaryItem(input: $input) {
    id
    __typename
  }
}
    `;

export function useUpdateSupplementaryItemMutation() {
  return Urql.useMutation<UpdateSupplementaryItemMutation, UpdateSupplementaryItemMutationVariables>(UpdateSupplementaryItemDocument);
};
export const UpdateTransferRequestDocument = gql`
    mutation UpdateTransferRequest($input: UpdateTransferRequestInput!) {
  updateTransferRequest(input: $input) {
    id
    __typename
  }
}
    `;

export function useUpdateTransferRequestMutation() {
  return Urql.useMutation<UpdateTransferRequestMutation, UpdateTransferRequestMutationVariables>(UpdateTransferRequestDocument);
};
export const CanSettleBookingDocument = gql`
    query CanSettleBooking($input: CanSettleBookingInput!) {
  canSettleBooking(input: $input) {
    canSettle
    required
    available
    reason
  }
}
    `;

export function useCanSettleBookingQuery(options: Omit<Urql.UseQueryArgs<CanSettleBookingQueryVariables>, 'query'>) {
  return Urql.useQuery<CanSettleBookingQuery, CanSettleBookingQueryVariables>({ query: CanSettleBookingDocument, ...options });
};
export const CancelBookingDocument = gql`
    mutation CancelBooking($input: CancelBookingInput!) {
  cancelBooking(input: $input) {
    id
    __typename
    status
  }
}
    `;

export function useCancelBookingMutation() {
  return Urql.useMutation<CancelBookingMutation, CancelBookingMutationVariables>(CancelBookingDocument);
};
export const GetActivityForEntityDocument = gql`
    query GetActivityForEntity($input: ActivityForEntityInput!) {
  activityForEntity(input: $input) {
    id
    type
    summary
    createdAt
    actor {
      id
      name
    }
    changes {
      property
      label
      before
      after
    }
  }
}
    `;

export function useGetActivityForEntityQuery(options: Omit<Urql.UseQueryArgs<GetActivityForEntityQueryVariables>, 'query'>) {
  return Urql.useQuery<GetActivityForEntityQuery, GetActivityForEntityQueryVariables>({ query: GetActivityForEntityDocument, ...options });
};
export const GetAgentByIdDocument = gql`
    query GetAgentById($input: GetAgentByIdInput!) {
  getAgentById(input: $input) {
    id
    __typename
    name
    email
    phoneNumber
    contactName
    url
    createdAt
    workspaces {
      id
      name
      displayName
      namespace
    }
    commissions {
      commissionPercentage
      offering {
        id
        name
      }
    }
    bookingsConnection(first: 100) {
      edges {
        node {
          id
          reference
          status
          arrivalDate
          departureDate
          customer {
            id
            name
          }
          invoices {
            id
            status
            netPrice
            grossPrice
            amountEarned
            amountOwed
          }
          settlement {
            settled
            settledAt
          }
        }
      }
    }
  }
}
    `;

export function useGetAgentByIdQuery(options: Omit<Urql.UseQueryArgs<GetAgentByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAgentByIdQuery, GetAgentByIdQueryVariables>({ query: GetAgentByIdDocument, ...options });
};
export const GetAgentLedgerSummaryDocument = gql`
    query GetAgentLedgerSummary($input: GetAgentLedgerSummaryInput!) {
  getAgentLedgerSummary(input: $input) {
    totalOwedToNivaas
    totalPaidToNivaas
    pendingPayments
    availableCredit
    outstandingBalance
  }
}
    `;

export function useGetAgentLedgerSummaryQuery(options: Omit<Urql.UseQueryArgs<GetAgentLedgerSummaryQueryVariables>, 'query'>) {
  return Urql.useQuery<GetAgentLedgerSummaryQuery, GetAgentLedgerSummaryQueryVariables>({ query: GetAgentLedgerSummaryDocument, ...options });
};
export const GetBookingByIdDocument = gql`
    query GetBookingById($input: GetBookingInput!) {
  getBooking(input: $input) {
    ...BookingFragment
  }
}
    ${BookingFragmentFragmentDoc}`;

export function useGetBookingByIdQuery(options: Omit<Urql.UseQueryArgs<GetBookingByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetBookingByIdQuery, GetBookingByIdQueryVariables>({ query: GetBookingByIdDocument, ...options });
};
export const ListInventoryItemsDocument = gql`
    query ListInventoryItems($input: ListInventoryItemsInput!) {
  listInventoryItems(input: $input) {
    __typename
    id
    available
  }
}
    `;

export function useListInventoryItemsQuery(options: Omit<Urql.UseQueryArgs<ListInventoryItemsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListInventoryItemsQuery, ListInventoryItemsQueryVariables>({ query: ListInventoryItemsDocument, ...options });
};
export const GetLeadDocument = gql`
    query GetLead($input: GetLeadInput!) {
  getLead(input: $input) {
    id
    createdAt
    updatedAt
    customer {
      name
      email
      phoneNumber
    }
    items {
      offering {
        id
        name
      }
      quantity
    }
    arrivalDate
    departureDate
    guests {
      fullName
      age
      gender
    }
    notes
    status
    source
  }
}
    `;

export function useGetLeadQuery(options: Omit<Urql.UseQueryArgs<GetLeadQueryVariables>, 'query'>) {
  return Urql.useQuery<GetLeadQuery, GetLeadQueryVariables>({ query: GetLeadDocument, ...options });
};
export const GetStaffByIdDocument = gql`
    query GetStaffById($input: GetStaffByIdInput!) {
  getStaffById(input: $input) {
    id
    __typename
    name
  }
}
    `;

export function useGetStaffByIdQuery(options: Omit<Urql.UseQueryArgs<GetStaffByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetStaffByIdQuery, GetStaffByIdQueryVariables>({ query: GetStaffByIdDocument, ...options });
};
export const GetTeamByIdDocument = gql`
    query GetTeamById($input: GetTeamByIdInput!) {
  getTeamById(input: $input) {
    id
    name
    type
    email
    phoneNumber
    contactName
    url
    createdAt
    workspaces {
      id
      name
      namespace
    }
  }
}
    `;

export function useGetTeamByIdQuery(options: Omit<Urql.UseQueryArgs<GetTeamByIdQueryVariables>, 'query'>) {
  return Urql.useQuery<GetTeamByIdQuery, GetTeamByIdQueryVariables>({ query: GetTeamByIdDocument, ...options });
};
export const ListAgentPaymentsDocument = gql`
    query ListAgentPayments($input: ListAgentPaymentsInput!) {
  listAgentPayments(input: $input) {
    id
    amount {
      amount
      currency
    }
    reference
    note
    status
    confirmedAt
    createdAt
    updatedAt
    createdBy {
      id
      name
    }
    confirmedBy {
      id
      name
    }
  }
}
    `;

export function useListAgentPaymentsQuery(options: Omit<Urql.UseQueryArgs<ListAgentPaymentsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListAgentPaymentsQuery, ListAgentPaymentsQueryVariables>({ query: ListAgentPaymentsDocument, ...options });
};
export const ListAgentsDocument = gql`
    query ListAgents($input: ListAgentsInput!) {
  listAgents(input: $input) {
    id
    __typename
    name
    email
    phoneNumber
    contactName
    url
    createdAt
    workspaces {
      id
      name
    }
    commissions {
      commissionPercentage
      offering {
        id
        name
      }
    }
  }
}
    `;

export function useListAgentsQuery(options: Omit<Urql.UseQueryArgs<ListAgentsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListAgentsQuery, ListAgentsQueryVariables>({ query: ListAgentsDocument, ...options });
};
export const ListAvailableRoomOfferingsDocument = gql`
    query ListAvailableRoomOfferings($input: ListAvailableRoomOfferingsInput!) {
  listAvailableRoomOfferings(input: $input) {
    id
    __typename
    pricing {
      unitPrice {
        amount
        currency
      }
      gst
      applicableFromDate
      applicableUntilDate
      applicableOnDates
    }
    name
    slug
    capacity
    inventory
    description
    availableFromDate
    availableUntilDate
  }
}
    `;

export function useListAvailableRoomOfferingsQuery(options: Omit<Urql.UseQueryArgs<ListAvailableRoomOfferingsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListAvailableRoomOfferingsQuery, ListAvailableRoomOfferingsQueryVariables>({ query: ListAvailableRoomOfferingsDocument, ...options });
};
export const ListBookingsDocument = gql`
    query ListBookings($input: ListBookingsInput!) {
  listBookings(input: $input) {
    ...BookingFragment
  }
}
    ${BookingFragmentFragmentDoc}`;

export function useListBookingsQuery(options: Omit<Urql.UseQueryArgs<ListBookingsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListBookingsQuery, ListBookingsQueryVariables>({ query: ListBookingsDocument, ...options });
};
export const ListCustomersDocument = gql`
    query ListCustomers($input: ListCustomersInput!) {
  listCustomers(input: $input) {
    id
    __typename
    name
    phoneNumber
    email
    type
    bookingsConnection {
      edges {
        node {
          id
          __typename
          status
          arrivalDate
          departureDate
        }
      }
    }
  }
}
    `;

export function useListCustomersQuery(options: Omit<Urql.UseQueryArgs<ListCustomersQueryVariables>, 'query'>) {
  return Urql.useQuery<ListCustomersQuery, ListCustomersQueryVariables>({ query: ListCustomersDocument, ...options });
};
export const ListInventoryItemsVerboseDocument = gql`
    query ListInventoryItemsVerbose($input: ListInventoryItemsVerboseInput!) {
  listInventoryItemsVerbose(input: $input) {
    id
    taken
    inventory
    pax
    availableRoomIds
  }
}
    `;

export function useListInventoryItemsVerboseQuery(options: Omit<Urql.UseQueryArgs<ListInventoryItemsVerboseQueryVariables>, 'query'>) {
  return Urql.useQuery<ListInventoryItemsVerboseQuery, ListInventoryItemsVerboseQueryVariables>({ query: ListInventoryItemsVerboseDocument, ...options });
};
export const ListLeadsDocument = gql`
    query ListLeads($input: ListLeadsInput!) {
  listLeads(input: $input) {
    id
    createdAt
    updatedAt
    customer {
      name
      email
      phoneNumber
    }
    items {
      offering {
        id
        name
      }
      quantity
    }
    supplementaryItems {
      name
      price {
        amount
        currency
      }
      quantity
      gst
    }
    arrivalDate
    departureDate
    guests {
      fullName
      age
      gender
    }
    notes
    status
    source
  }
}
    `;

export function useListLeadsQuery(options: Omit<Urql.UseQueryArgs<ListLeadsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListLeadsQuery, ListLeadsQueryVariables>({ query: ListLeadsDocument, ...options });
};
export const ListPackagesDocument = gql`
    query ListPackages($input: ListPackagesInput!) {
  listPackages(input: $input) {
    id
    __typename
    name
    slug
    description
    allowedOfferings {
      id
      name
      slug
    }
    supplementaryItems {
      name
      price {
        amount
        currency
      }
      quantity
      gst
    }
    availableFromDate
    availableUntilDate
    isActive
    createdAt
  }
}
    `;

export function useListPackagesQuery(options: Omit<Urql.UseQueryArgs<ListPackagesQueryVariables>, 'query'>) {
  return Urql.useQuery<ListPackagesQuery, ListPackagesQueryVariables>({ query: ListPackagesDocument, ...options });
};
export const ListReservationsDocument = gql`
    query ListReservations($input: ListReservationsInput!) {
  listReservations(input: $input) {
    id
    __typename
    status
    arrivalDate
    departureDate
    createdAt
    updatedAt
    createdBy {
      id
      __typename
      name
    }
    updatedBy {
      id
      __typename
      name
    }
    items {
      room {
        id
        __typename
        offering {
          name
          inventory
        }
      }
      reference
      references
    }
    customer {
      id
      __typename
      name
      phoneNumber
      email
      type
    }
    booking {
      id
      __typename
      reference
      createdAt
      source
      status
      guests {
        __typename
        id
        attribution
        age
        fullName
      }
      instructions
      notes
      transfers {
        __typename
        id
        type
        details
        location
        scheduledAt
        scheduledTime
      }
      customer {
        __typename
        id
        name
      }
    }
  }
}
    `;

export function useListReservationsQuery(options: Omit<Urql.UseQueryArgs<ListReservationsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListReservationsQuery, ListReservationsQueryVariables>({ query: ListReservationsDocument, ...options });
};
export const ListRoomOfferingsDocument = gql`
    query ListRoomOfferings($input: ListRoomOfferingsInput!) {
  listRoomOfferings(input: $input) {
    id
    __typename
    pricing {
      unitPrice {
        amount
        currency
      }
      gst
      applicableFromDate
      applicableUntilDate
      applicableOnDates
    }
    extras {
      type
      name
      maxQuantityPerRoom
      price {
        amount
        currency
      }
      gst
    }
    name
    slug
    capacity
    inventory
    description
    availableFromDate
    availableUntilDate
  }
}
    `;

export function useListRoomOfferingsQuery(options: Omit<Urql.UseQueryArgs<ListRoomOfferingsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListRoomOfferingsQuery, ListRoomOfferingsQueryVariables>({ query: ListRoomOfferingsDocument, ...options });
};
export const ListRoomsDocument = gql`
    query ListRooms($input: ListAllRoomsInput!) {
  listAllRooms(input: $input) {
    id
    __typename
    slots
    status
    offering {
      id
      __typename
      slug
      name
      capacity
      inventory
    }
  }
}
    `;

export function useListRoomsQuery(options: Omit<Urql.UseQueryArgs<ListRoomsQueryVariables>, 'query'>) {
  return Urql.useQuery<ListRoomsQuery, ListRoomsQueryVariables>({ query: ListRoomsDocument, ...options });
};
export const ListTeamStaffDocument = gql`
    query ListTeamStaff($input: ListTeamStaffInput!) {
  listTeamStaff(input: $input) {
    id
    name
    email
    role
    status
    createdAt
  }
}
    `;

export function useListTeamStaffQuery(options: Omit<Urql.UseQueryArgs<ListTeamStaffQueryVariables>, 'query'>) {
  return Urql.useQuery<ListTeamStaffQuery, ListTeamStaffQueryVariables>({ query: ListTeamStaffDocument, ...options });
};
export const ListWorkspacesDocument = gql`
    query ListWorkspaces($input: ListWorkspacesInput!) {
  listWorkspaces(input: $input) {
    id
    __typename
    displayName
    name
    namespace
    roomOfferingsConnection(first: 100) {
      edges {
        node {
          id
          name
          slug
        }
      }
    }
  }
}
    `;

export function useListWorkspacesQuery(options: Omit<Urql.UseQueryArgs<ListWorkspacesQueryVariables>, 'query'>) {
  return Urql.useQuery<ListWorkspacesQuery, ListWorkspacesQueryVariables>({ query: ListWorkspacesDocument, ...options });
};
export const MyNotificationsDocument = gql`
    query MyNotifications($input: MyNotificationsInput!) {
  myNotifications(input: $input) {
    notifications {
      id
      title
      body
      read
      readAt
      createdAt
      entityId
      notificationType
    }
    unreadCount
  }
}
    `;

export function useMyNotificationsQuery(options: Omit<Urql.UseQueryArgs<MyNotificationsQueryVariables>, 'query'>) {
  return Urql.useQuery<MyNotificationsQuery, MyNotificationsQueryVariables>({ query: MyNotificationsDocument, ...options });
};
export const UnreadNotificationCountDocument = gql`
    query UnreadNotificationCount($input: UnreadNotificationCountInput!) {
  unreadNotificationCount(input: $input)
}
    `;

export function useUnreadNotificationCountQuery(options: Omit<Urql.UseQueryArgs<UnreadNotificationCountQueryVariables>, 'query'>) {
  return Urql.useQuery<UnreadNotificationCountQuery, UnreadNotificationCountQueryVariables>({ query: UnreadNotificationCountDocument, ...options });
};